<template>
	<div
		class="overlay-menu"
		:class="{ sidenavopen: showOverlayMenu }"
		@click="$emit('close')"
	>
		<div class="overlay-menu__container">
			<div class="overlay-menu__section">
				<div class="overlay-menu__header">
					<div class="hambager" @click="$emit('close')">
						<div
							class="hambager__bar"
							:class="{ topopen: showOverlayMenu }"
						></div>
						<div
							class="hambager__bar short"
							:class="{ midopen: showOverlayMenu }"
						></div>
						<div
							class="hambager__bar"
							:class="{ botopen: showOverlayMenu }"
						></div>
					</div>
					<div class="overlay-menu__logo">
						<logo @click.native="openRoute('/')" />
					</div>
				</div>
				<!-- <input type="search" /> -->
				<div class="overlay-menu__nav">
					<div class="overlay-menu__strocked-card">
						<div class="overlay-menu__nav__item">
							<button
								class="overlay-menu__nav__button"
								@click="openRoute('/')"
								aria-pressed="true"
								aria-describedby="a11y__link-button--prematch"
								:aria-label="$t('overlay-menu.prematch') + ' icon'"
							>
								<svg
									class="overlay-menu__nav__icon"
									viewBox="0 0 20 20"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										d="M13.0859 20H6.95312C4.36844 20 2.26562 17.8972 2.26562 15.3125V9.51629C2.26562 8.78219 1.94945 8.08316 1.39816 7.59844C0.509609 6.81711 0 5.69039 0 4.50715V3.97254C0 2.20605 1.32156 0.706641 3.0741 0.484766L6.855 0.00617188C6.88754 0.00207031 6.92031 0 6.95312 0H13.125C13.1582 0 13.1914 0.00210937 13.2243 0.00632813L16.9314 0.481602C18.6808 0.705898 20 2.205 20 3.96871V4.52449C20 5.6941 19.5001 6.81223 18.6284 7.59215L18.6218 7.59805C18.0836 8.07961 17.7734 8.77332 17.7734 9.49895V15.3125C17.7734 17.8972 15.6706 20 13.0859 20ZM7.00238 1.5625L3.27035 2.03492C2.29672 2.15816 1.5625 2.99117 1.5625 3.97258V4.50719C1.5625 5.24129 1.87867 5.94031 2.42996 6.42504C3.31852 7.20633 3.82812 8.33305 3.82812 9.51629V15.3125C3.82812 17.0356 5.23 18.4375 6.95312 18.4375H13.0859C14.8091 18.4375 16.2109 17.0356 16.2109 15.3125V9.49895C16.2109 8.32934 16.7109 7.21121 17.5825 6.43129L17.5891 6.42539C18.1273 5.94383 18.4375 5.25012 18.4375 4.52449V3.96871C18.4375 2.98891 17.7046 2.15605 16.7327 2.03145L13.0751 1.5625H7.00238ZM13.5324 4.18223C13.9006 3.95723 14.0176 3.47582 13.7926 3.10766C13.5676 2.73949 13.0878 2.62289 12.7195 2.84781C12.7072 2.85527 11.4662 3.59375 10.0391 3.59375C8.61875 3.59375 7.38277 2.8623 7.35887 2.84797C6.99086 2.62437 6.51113 2.74059 6.28652 3.10824C6.06152 3.47641 6.17758 3.95727 6.54578 4.18227C6.61082 4.22199 8.16117 5.15625 10.0391 5.15625C11.917 5.15625 13.4673 4.22199 13.5324 4.18223ZM8.51562 14.2188V9.72758C8.51562 9.20785 8.23469 8.72594 7.78242 8.46988C7.33016 8.21379 6.77242 8.22086 6.32668 8.48824C6.3248 8.48938 6.32293 8.49051 6.32102 8.49164L5.64703 8.90379C5.27894 9.12891 5.16301 9.60977 5.38813 9.97789C5.61324 10.346 6.0941 10.4618 6.46223 10.2368L6.95312 9.93664V14.2188C6.95312 14.6502 7.30289 15 7.73438 15C8.16586 15 8.51562 14.6502 8.51562 14.2188ZM12.3242 15C11.0211 15 9.96094 13.9398 9.96094 12.6367V10.6445C9.96094 9.34141 11.0211 8.28125 12.3242 8.28125C13.6273 8.28125 14.6875 9.34141 14.6875 10.6445V12.6367C14.6875 13.9398 13.6273 15 12.3242 15ZM12.3242 9.84375C11.8827 9.84375 11.5234 10.203 11.5234 10.6445V12.6367C11.5234 13.0783 11.8827 13.4375 12.3242 13.4375C12.7658 13.4375 13.125 13.0783 13.125 12.6367V10.6445C13.125 10.203 12.7658 9.84375 12.3242 9.84375Z"
									/>
								</svg>
								<span>{{ $t("overlay-menu.prematch") }}</span>
							</button>
							<span
								id="a11y__link-button--prematch"
								class="a11y__visually-hidden"
								aria-hidden="true"
								>{{ $t("overlay-menu.prematch") }} link, opens a new tab.</span
							>
						</div>
						<div class="overlay-menu__nav__item">
							<button
								class="overlay-menu__nav__button"
								@click="openRoute('/live')"
								aria-pressed="true"
								aria-describedby="a11y__link-button--live-games"
								:aria-label="$t('overlay-menu.live-games') + ' icon'"
							>
								<svg
									class="overlay-menu__nav__icon"
									viewBox="0 0 20 16"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										d="M16.0511 2.04823C14.6603 1.91205 12.4816 1.74974 9.99987 1.74974C7.51819 1.74974 5.3394 1.91201 3.94863 2.04823C2.86401 2.1544 1.99997 2.98109 1.84739 4.05861C1.65816 5.39473 1.56222 6.72073 1.56222 7.99989C1.56222 9.27906 1.65816 10.605 1.84739 11.9411C1.99997 13.0187 2.86401 13.8454 3.94863 13.9516C5.33944 14.0877 7.51819 14.25 9.99987 14.25C12.4816 14.25 14.6603 14.0878 16.0511 13.9516C17.1357 13.8454 17.9998 13.0187 18.1524 11.9412C18.2129 11.5139 18.6083 11.2166 19.0354 11.2771C19.4627 11.3376 19.7599 11.733 19.6995 12.1602C19.4454 13.9539 18.0078 15.33 16.2033 15.5067C14.7779 15.6462 12.5446 15.8125 9.99983 15.8125C7.45506 15.8125 5.22178 15.6462 3.79637 15.5067C1.99188 15.3301 0.554238 13.9539 0.30021 12.1602C-0.10007 9.31917 -0.10007 6.68061 0.30021 3.83955C0.554238 2.04588 1.99188 0.669725 3.79637 0.493121C5.22174 0.353587 7.45506 0.187256 9.99983 0.187256C12.5446 0.187256 14.7779 0.353587 16.2033 0.493121C18.0078 0.669725 19.4454 2.04588 19.6995 3.83959C19.8989 5.24801 20 6.64772 20 7.99989C19.9592 9.03546 18.4788 9.03667 18.4375 7.99989C18.4375 6.72077 18.3415 5.39477 18.1523 4.05869C17.9998 2.98109 17.1357 2.1544 16.0511 2.04823V2.04823ZM13.0276 6.74471C14.0374 7.30863 14.0372 8.82803 13.0276 9.39175L9.67385 11.3378C9.19669 11.6147 8.62641 11.6157 8.14843 11.3403C7.66893 11.0642 7.38264 10.5685 7.38264 10.0143V6.12213C7.38264 5.56794 7.66893 5.07226 8.14843 4.79613C8.62641 4.52081 9.19669 4.52182 9.67385 4.79863L13.0276 6.74471ZM12.1951 8.06825L8.94517 6.1824V9.95418L12.1951 8.06825Z"
									/>
								</svg>
								<span>{{ $t("overlay-menu.live-games") }}</span>
							</button>
							<span
								id="a11y__link-button--live-games"
								class="a11y__visually-hidden"
								aria-hidden="true"
								>{{ $t("overlay-menu.live-games") }} link, opens a new
								tab.</span
							>
						</div>

						<div
							class="overlay-menu__nav__item"
							v-if="productAvailable('jackpots')"
						>
							<router-link
								class="account_section button link no-bg no-padding full"
								:to="{ name: jackpot.routeName }"
								:class="{
									selected:
										[
											'jackpots',
											'grand-jackpot',
											'midweek-jackpot',
											'must-be-won',
											'jackpot-results',
											'jackpot-result',
											'boosted-multibet-events',
										].indexOf($route.name) > -1,
								}"
							>
								<svg
									class="overlay-menu__nav__icon"
									viewBox="0 0 18 20"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										d="M9.00811 10.8971C8.46182 10.8971 7.91597 10.7837 7.40961 10.5572L3.00587 8.72255C1.54491 8.11139 0.601562 6.69418 0.601562 5.11166V3.91374C0.601562 1.75568 2.35725 0 4.51527 0H13.4845C15.6425 0 17.3982 1.75568 17.3982 3.9137V5.11162C17.3982 6.69414 16.4549 8.11135 14.995 8.72208L10.5182 10.595C10.0365 10.7966 9.52212 10.8971 9.00811 10.8971ZM4.51527 1.56248C3.2188 1.56248 2.16404 2.61723 2.16404 3.9137V5.11162C2.16404 6.06235 2.73076 6.91375 3.60782 7.28066L8.02034 9.11896C8.0273 9.12185 8.03417 9.12485 8.04105 9.12794C8.63295 9.39489 9.31607 9.40426 9.91516 9.15364L14.392 7.2807C15.269 6.91375 15.8358 6.06239 15.8358 5.11166V3.91374C15.8358 2.61727 14.781 1.56252 13.4845 1.56252H4.51527V1.56248ZM12.7108 5.74212V3.78902C12.6695 2.75247 11.1892 2.75325 11.1483 3.78902V5.74212C11.1483 6.1736 11.4981 6.52336 11.9296 6.52336C12.361 6.52336 12.7108 6.1736 12.7108 5.74212ZM6.85149 5.74212V3.78902C6.81024 2.75247 5.32991 2.75325 5.28901 3.78902V5.74212C5.28901 6.1736 5.63877 6.52336 6.07025 6.52336C6.50173 6.52336 6.85149 6.1736 6.85149 5.74212ZM9.8202 5.78118V3.82808C9.77895 2.79153 8.29862 2.79231 8.25772 3.82808V5.78118C8.25772 6.21266 8.60748 6.56242 9.03896 6.56242C9.47044 6.56242 9.8202 6.21266 9.8202 5.78118ZM7.39121 19.9998C6.45708 20.015 5.68088 19.1145 5.86099 18.1871L6.0363 17.1732L5.29264 16.4539C4.36652 15.574 4.88862 13.9805 6.15279 13.8108L7.18551 13.6619L7.64621 12.7357C8.20112 11.5937 9.87704 11.5941 10.4317 12.7357L10.8924 13.6619L11.9251 13.8109C13.1897 13.9807 13.7111 15.5743 12.7852 16.454L12.0416 17.1732L12.2169 18.1871C12.3176 18.7699 12.0828 19.3491 11.604 19.6986C11.1219 20.0504 10.4936 20.0975 9.96407 19.8214L9.03736 19.338L8.11386 19.8214C7.88488 19.9408 7.63738 19.9998 7.39121 19.9998ZM6.40255 15.3535L7.12863 16.0559C7.49687 16.412 7.66476 16.9254 7.57769 17.4294L7.40488 18.4289L8.31792 17.9527C8.7694 17.7171 9.30849 17.7171 9.76005 17.9527L10.673 18.4288L10.5002 17.4294C10.4132 16.9254 10.5811 16.412 10.9493 16.0558L11.6755 15.3535L10.6661 15.2079C10.1604 15.1351 9.7229 14.8192 9.49603 14.3631L9.03896 13.4442L8.5819 14.3631C8.35499 14.8192 7.91757 15.1351 7.41179 15.2079L6.40255 15.3535Z"
									/>
								</svg>
								<span>{{ $t("overlay-menu.jackpots") }}</span>
							</router-link>
						</div>
						<div
							v-if="productAvailable('crashGames')"
							class="overlay-menu__nav__item"
						>
							<button
								class="overlay-menu__nav__button"
								@click="openRoute(`/crash-games`)"
								aria-pressed="true"
								aria-describedby="a11y__link-button--casino"
								aria-label="Crash Games icon"
							>
								<svg
									class="overlay-menu__nav__icon"
									id="crashgames"
									xmlns="http://www.w3.org/2000/svg"
									viewBox="0 0 25 24"
									fill="none"
								>
									<path
										d="M20.8659 1.96681L15.1799 0.22081C13.9248 -0.161429 12.5699 -0.0361962 11.4062 0.56961C10.2424 1.17542 9.36267 2.21347 8.9559 3.46081L8.7679 3.99981H5.3999C4.07431 4.00139 2.80346 4.52869 1.86612 5.46602C0.928784 6.40336 0.40149 7.67421 0.399902 8.9998L0.399902 18.9998C0.40149 20.3254 0.928784 21.5962 1.86612 22.5336C2.80346 23.4709 4.07431 23.9982 5.3999 23.9998H11.3999C12.1574 23.9971 12.9043 23.8215 13.5837 23.4864C14.263 23.1512 14.8569 22.6653 15.3199 22.0658C15.5481 22.0989 15.7783 22.1163 16.0089 22.1178C17.0827 22.1186 18.128 21.7721 18.9886 21.1299C19.8492 20.4877 20.479 19.5844 20.7839 18.5548L24.1999 8.1558C24.5648 6.8931 24.4201 5.53765 23.7967 4.38049C23.1734 3.22333 22.1211 2.35675 20.8659 1.96681ZM11.3999 21.9998H5.3999C4.60425 21.9998 3.84119 21.6837 3.27858 21.1211C2.71597 20.5585 2.3999 19.7954 2.3999 18.9998V8.9998C2.3999 8.20415 2.71597 7.44109 3.27858 6.87848C3.84119 6.31587 4.60425 5.9998 5.3999 5.9998H11.3999C12.1956 5.9998 12.9586 6.31587 13.5212 6.87848C14.0838 7.44109 14.3999 8.20415 14.3999 8.9998V18.9998C14.3999 19.7954 14.0838 20.5585 13.5212 21.1211C12.9586 21.6837 12.1956 21.9998 11.3999 21.9998ZM22.2869 7.5628L18.8749 17.9628C18.7054 18.5381 18.3668 19.0492 17.9032 19.4297C17.4395 19.8103 16.8723 20.0427 16.2749 20.0968C16.357 19.7369 16.3989 19.3689 16.3999 18.9998V8.9998C16.3983 7.67421 15.871 6.40336 14.9337 5.46602C13.9963 4.52869 12.7255 4.00139 11.3999 3.99981H10.8929C11.151 3.27238 11.6796 2.67244 12.3687 2.32472C13.0578 1.977 13.8544 1.90827 14.5929 2.13281L20.2789 3.87881C21.0278 4.1099 21.6569 4.62436 22.0319 5.31253C22.407 6.0007 22.4985 6.80816 22.2869 7.5628ZM12.3999 12.9998C12.3999 14.4498 10.8559 16.3908 9.6859 17.3778C9.32643 17.6819 8.87078 17.8488 8.3999 17.8488C7.92902 17.8488 7.47338 17.6819 7.1139 17.3778C5.9439 16.3908 4.3999 14.4498 4.3999 12.9998C4.3999 12.4694 4.61062 11.9607 4.98569 11.5856C5.36076 11.2105 5.86947 10.9998 6.3999 10.9998C6.93034 10.9998 7.43904 11.2105 7.81412 11.5856C8.18919 11.9607 8.3999 12.4694 8.3999 12.9998C8.3999 12.4694 8.61062 11.9607 8.98569 11.5856C9.36076 11.2105 9.86947 10.9998 10.3999 10.9998C10.9303 10.9998 11.439 11.2105 11.8141 11.5856C12.1892 11.9607 12.3999 12.4694 12.3999 12.9998Z"
										style="fill: var(--black)"
									/>
								</svg>
								<span>Crash Games</span>
							</button>
							<span
								id="a11y__link-button--casino"
								class="a11y__visually-hidden"
								aria-hidden="true"
								>Aviator link, opens a new tab.</span
							>
						</div>

						<div
							class="overlay-menu__nav__item"
							v-if="productAvailable('virtuals')"
						>
							<button
								class="overlay-menu__nav__button"
								@click="openRoute('/virtual')"
								aria-pressed="true"
								aria-describedby="a11y__link-button--virtual-games"
								:aria-label="$t('overlay-menu.virtual-games') + ' icon'"
							>
								<svg
									class="overlay-menu__nav__icon"
									viewBox="0 0 18 20"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										d="M8.98453 15.9412C8.16434 15.9412 7.37047 15.6477 6.74742 15.1137L2.19941 11.2154C1.1591 10.3238 0.5625 9.02652 0.5625 7.65637V4.6875C0.5625 2.10281 2.66531 0 5.25 0H13.0625C15.6472 0 17.75 2.10281 17.75 4.6875V7.28656C17.75 8.64078 17.1648 9.92816 16.1444 10.8185L11.2445 15.0939C10.6225 15.6366 9.82523 15.9375 8.99969 15.9412C8.99465 15.9412 8.98953 15.9412 8.98453 15.9412ZM5.25 1.5625C3.52688 1.5625 2.125 2.96438 2.125 4.6875V7.65637C2.125 8.56981 2.52277 9.43457 3.21629 10.029L7.7643 13.9273C8.46629 14.5289 9.52078 14.5243 10.2173 13.9166L15.1171 9.64121C15.7973 9.04762 16.1875 8.18937 16.1875 7.28656V4.6875C16.1875 2.96438 14.7856 1.5625 13.0625 1.5625H5.25ZM9.78125 19.2188V18.1641C9.74 17.1275 8.25965 17.1283 8.21875 18.1641V19.2188C8.21875 19.6502 8.56852 20 9 20C9.43148 20 9.78125 19.6502 9.78125 19.2188ZM12.5938 17.9688V16.875C12.5525 15.8384 11.0721 15.8392 11.0312 16.875V17.9688C11.0312 18.4002 11.381 18.75 11.8125 18.75C12.244 18.75 12.5938 18.4002 12.5938 17.9688ZM15.1328 15.7422V14.6484C15.0916 13.6119 13.6112 13.6127 13.5703 14.6484V15.7422C13.5703 16.1737 13.9201 16.5234 14.3516 16.5234C14.783 16.5234 15.1328 16.1737 15.1328 15.7422ZM17.75 13.3984V12.3047C17.7087 11.2681 16.2284 11.2689 16.1875 12.3047V13.3984C16.1875 13.8299 16.5373 14.1797 16.9688 14.1797C17.4002 14.1797 17.75 13.8299 17.75 13.3984ZM6.96875 17.9688V16.875C6.9275 15.8384 5.44715 15.8392 5.40625 16.875V17.9688C5.40625 18.4002 5.75602 18.75 6.1875 18.75C6.61898 18.75 6.96875 18.4002 6.96875 17.9688ZM4.42969 15.7422V14.6484C4.38844 13.6119 2.90809 13.6127 2.86719 14.6484V15.7422C2.86719 16.1737 3.21695 16.5234 3.64844 16.5234C4.07992 16.5234 4.42969 16.1737 4.42969 15.7422ZM1.8125 13.3984V12.3047C1.77125 11.2681 0.290898 11.2689 0.25 12.3047V13.3984C0.25 13.8299 0.599766 14.1797 1.03125 14.1797C1.46273 14.1797 1.8125 13.8299 1.8125 13.3984ZM10.367 10.3907C10.1412 10.3908 9.91438 10.3365 9.70453 10.2265L9 9.85734L8.29543 10.2265C7.26785 10.7777 6.02402 9.87602 6.23246 8.7282L6.36641 7.94973L5.79844 7.39793C4.95289 6.59133 5.42926 5.13051 6.58629 4.97418L7.37332 4.8602L7.7248 4.15035C8.23223 3.10105 9.76809 3.10141 10.2752 4.15035L10.6267 4.8602L11.4138 4.97418C12.5712 5.13066 13.0469 6.59172 12.2016 7.39793L11.6336 7.94973L11.7676 8.72828C11.8598 9.26418 11.6438 9.79613 11.2037 10.1165C10.9539 10.2983 10.6614 10.3907 10.367 10.3907ZM9 8.27707C9.22703 8.27707 9.45406 8.33129 9.66102 8.43973L10.1792 8.71125L10.0809 8.14004C10.0014 7.67859 10.1547 7.20801 10.4909 6.88141L10.9049 6.47926L10.3303 6.39605C9.86715 6.32898 9.4668 6.03883 9.25934 5.61992L9 5.09613L8.74066 5.61984C8.5332 6.03879 8.13285 6.32891 7.66969 6.39602L7.09512 6.47922L7.5091 6.88144C7.84527 7.20797 7.99855 7.67855 7.91906 8.14012L7.82078 8.71121L8.33898 8.43969C8.54594 8.33129 8.77297 8.27707 9 8.27707Z"
									/>
								</svg>
								<span>{{ $t("overlay-menu.virtual-games") }}</span>
							</button>
							<span
								id="a11y__link-button--virtual-games"
								class="a11y__visually-hidden"
								aria-hidden="true"
								>{{ $t("overlay-menu.virtual-games") }} link, opens a new
								tab.</span
							>
						</div>
						<div
							class="overlay-menu__nav__item"
							v-if="productAvailable('casino')"
						>
							<button
								class="overlay-menu__nav__button"
								@click="openRoute('/casino')"
								aria-pressed="true"
								aria-describedby="a11y__link-button--casino"
								:aria-label="$t('overlay-menu.casino') + ' icon'"
							>
								<svg
									class="overlay-menu__nav__icon"
									viewBox="0 0 20 20"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										d="M10 20C7.32891 20 4.8177 18.9598 2.92891 17.0711C1.0402 15.1823 0 12.6711 0 10C0 7.32891 1.0402 4.8177 2.92891 2.92891C4.8177 1.0402 7.32891 0 10 0C12.6711 0 15.1823 1.0402 17.0711 2.92891C18.9598 4.8177 20 7.32891 20 10C20 12.6711 18.9598 15.1823 17.0711 17.0711C15.1823 18.9598 12.6711 20 10 20ZM10 1.5625C5.34754 1.5625 1.5625 5.34754 1.5625 10C1.5625 14.6525 5.34754 18.4375 10 18.4375C14.6525 18.4375 18.4375 14.6525 18.4375 10C18.4375 5.34754 14.6525 1.5625 10 1.5625ZM9.84375 5.70312C9.84375 6.24246 10.281 6.67969 10.8203 6.67969C11.3596 6.67969 11.7969 6.24246 11.7969 5.70312C11.7969 5.16379 11.3596 4.72656 10.8203 4.72656C10.281 4.72656 9.84375 5.16379 9.84375 5.70312ZM13.3203 7.10938C13.3203 7.64871 13.7575 8.08594 14.2969 8.08594C14.8362 8.08594 15.2734 7.64871 15.2734 7.10938C15.2734 6.57004 14.8362 6.13281 14.2969 6.13281C13.7575 6.13281 13.3203 6.57004 13.3203 7.10938ZM10.5078 9.29688C10.5078 9.83621 10.945 10.2734 11.4844 10.2734C12.0237 10.2734 12.4609 9.83621 12.4609 9.29688C12.4609 8.75754 12.0237 8.32031 11.4844 8.32031C10.945 8.32031 10.5078 8.75754 10.5078 9.29688Z"
									/>
								</svg>
								<span>{{ $t("overlay-menu.casino") }}</span>
							</button>
							<span
								id="a11y__link-button--casino"
								class="a11y__visually-hidden"
								aria-hidden="true"
								>{{ $t("overlay-menu.casino") }} link, opens a new tab.</span
							>
						</div>
						<div class="overlay-menu__nav__item" v-if="jackpotSababisha">
							<router-link
								class="account_section button link no-bg no-padding full"
								:to="{ name: jackpotSababisha.routeName }"
								:class="{
									selected:
										$route.path ==
										`/${jackpot.name[env.locale]
											.split(' ')
											.join('-')
											.toLowerCase()}`,
								}"
							>
								<svg
									class="overlay-menu__nav__icon"
									viewBox="0 0 20 20"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										d="M19.6094 14.9034C18.6754 14.0741 17.6381 13.3689 16.5234 12.8054C16.382 13.0397 16.1328 13.385 15.9687 13.6015C15.7293 13.4843 15.4867 13.369 15.2395 13.2643C13.5628 12.5585 11.762 12.1948 9.94277 12.1948C8.12359 12.1948 6.32275 12.5585 4.64609 13.2643C4.40117 13.3679 4.16172 13.4804 3.925 13.5972C3.73906 13.3491 3.47578 12.9913 3.36328 12.8054C2.2472 13.3686 1.20865 14.0738 0.273438 14.9034L2.1 15.046L1.84375 16.889C2.64953 16.1576 3.55038 15.5385 4.52188 15.0483L5.02461 15.8655C6.5529 15.1086 8.23534 14.7147 9.94082 14.7147C11.6463 14.7147 13.3287 15.1086 14.857 15.8655L15.3594 15.0479C16.3316 15.538 17.2331 16.1573 18.0395 16.889L17.7828 15.046L19.6094 14.9034Z"
									/>
									<path
										d="M4.22891 12.6051C4.75452 12.3841 5.29254 12.194 5.84024 12.0355C5.1245 11.1244 4.73547 9.99927 4.73555 8.84062C4.73555 5.96991 7.0707 3.63476 9.94141 3.63476C12.8121 3.63476 15.1469 5.96991 15.1469 8.84062C15.1467 9.99954 14.7576 11.1249 14.0418 12.0363C14.5892 12.1943 15.1268 12.3842 15.652 12.6051C15.7211 12.6344 15.7902 12.666 15.8594 12.6969C16.5543 11.6309 16.9484 10.397 17 9.12553C17.0517 7.85408 16.7589 6.59229 16.1527 5.47347C15.5465 4.35464 14.6494 3.42032 13.5561 2.76922C12.4628 2.11812 11.2139 1.77441 9.94141 1.77441C8.66891 1.77441 7.42004 2.11812 6.32673 2.76922C5.23342 3.42032 4.33628 4.35464 3.73008 5.47347C3.12388 6.59229 2.83114 7.85408 2.88277 9.12553C2.93441 10.397 3.32851 11.6309 4.02344 12.6969C4.09141 12.6656 4.16016 12.634 4.22891 12.6051Z"
									/>
									<path
										d="M7.04629 17.0699L7.00293 16.6188L6.60645 16.3969L7.02363 16.2141L7.11269 15.7656L7.41426 16.1109L7.86504 16.057L7.63457 16.4477L7.82559 16.8602L7.3791 16.7645L7.04629 17.0699Z"
									/>
									<path
										d="M9.92461 17.6265L9.7332 17.214L9.2832 17.1417L9.61133 16.828L9.54219 16.3804L9.94102 16.5956L10.3508 16.3894L10.268 16.8397L10.5898 17.1632L10.1352 17.2194L9.92461 17.6265Z"
									/>
									<path
										d="M12.823 17.1606L12.4988 16.8438L12.0496 16.9298L12.2539 16.5212L12.0352 16.1185L12.4852 16.1903L12.7973 15.8579L12.8727 16.3079L13.2852 16.4989L12.8777 16.7095L12.823 17.1606Z"
									/>
									<path
										d="M8.05137 8.19837C7.8558 8.19837 7.71543 8.14394 7.63027 8.03509C7.55762 7.94264 7.52103 7.80996 7.52051 7.63704C7.52051 7.60657 7.52051 7.57415 7.52402 7.54017L7.89668 7.47376C7.89356 7.51282 7.8916 7.54759 7.8916 7.58079C7.8916 7.77741 7.95072 7.87571 8.06895 7.87571C8.09101 7.87695 8.11306 7.87308 8.13338 7.86441C8.15371 7.85574 8.17176 7.84249 8.18614 7.82571C8.21446 7.78848 8.23142 7.74385 8.23496 7.6972C8.23679 7.6819 8.2377 7.66651 8.2377 7.6511C8.23873 7.61253 8.23305 7.57406 8.2209 7.53743C8.20786 7.49377 8.18694 7.45287 8.15918 7.41673C8.12455 7.37526 8.08723 7.33611 8.04746 7.29954L7.83301 7.09407C7.76171 7.02888 7.70374 6.95048 7.66231 6.86321C7.63519 6.79721 7.62189 6.72635 7.62324 6.65501C7.62324 6.6261 7.6252 6.59602 7.62832 6.56438C7.63287 6.48909 7.65226 6.41543 7.68538 6.34765C7.71849 6.27988 7.76468 6.21932 7.82129 6.16946C7.93171 6.07649 8.07494 6.02948 8.25098 6.02844H8.25996C8.32913 6.027 8.39798 6.03826 8.46309 6.06165C8.51564 6.08036 8.56331 6.11066 8.60254 6.15032C8.63733 6.18927 8.6639 6.23484 8.68067 6.2843C8.69916 6.33469 8.71136 6.38717 8.717 6.44055C8.72054 6.47611 8.72184 6.51186 8.7209 6.54758C8.7209 6.5679 8.7209 6.58977 8.7209 6.61282L8.35059 6.67259C8.35332 6.62923 8.3545 6.58938 8.3545 6.55266C8.3545 6.53587 8.3545 6.51868 8.3545 6.50149C8.35448 6.45839 8.3408 6.41641 8.31543 6.38157C8.30384 6.3681 8.28925 6.35755 8.27283 6.35076C8.25641 6.34397 8.23862 6.34115 8.2209 6.34251H8.20957C8.18659 6.34286 8.16393 6.34797 8.14302 6.35752C8.12211 6.36707 8.10341 6.38084 8.08809 6.39797C8.05707 6.43344 8.0383 6.47796 8.03457 6.52493C8.03285 6.53788 8.03194 6.55093 8.03184 6.56399C8.03175 6.59752 8.03744 6.63082 8.04864 6.66243C8.05958 6.69741 8.07635 6.7303 8.09825 6.7597C8.12463 6.79136 8.1528 6.82149 8.18262 6.84993L8.39434 7.05267C8.43418 7.09129 8.47125 7.13267 8.50528 7.17649C8.53784 7.21933 8.56635 7.2651 8.59043 7.31321C8.61688 7.36629 8.63518 7.42305 8.64473 7.48157C8.65056 7.51695 8.65344 7.55275 8.65333 7.5886C8.65334 7.61759 8.65164 7.64654 8.64825 7.67532C8.63651 7.8211 8.56891 7.95671 8.45957 8.05384C8.34695 8.15237 8.2009 8.20409 8.05137 8.19837Z"
									/>
									<path
										d="M8.71094 8.1707L9.35195 6.05469H9.81133L10.0039 8.1707H9.61328L9.58281 7.69844H9.24219L9.11328 8.1707H8.71094ZM9.3082 7.43438H9.56602L9.52695 6.58672L9.3082 7.43438Z"
									/>
									<path
										d="M10.2129 8.17075L10.4348 6.05474H10.9684C11.0381 6.05416 11.1079 6.05886 11.177 6.0688C11.2364 6.07763 11.2943 6.09486 11.3488 6.11997C11.3989 6.14198 11.4431 6.17528 11.4781 6.21724C11.5134 6.2632 11.5376 6.31667 11.5488 6.37349C11.5577 6.41455 11.562 6.45647 11.5617 6.49849C11.5617 6.53218 11.5596 6.56583 11.5555 6.59927C11.5255 6.85474 11.4068 6.99797 11.1992 7.02896C11.4151 7.06776 11.5231 7.21047 11.5231 7.45708C11.523 7.48827 11.5214 7.51944 11.518 7.55044C11.4977 7.75721 11.4294 7.91229 11.3133 8.01568C11.1971 8.11906 11.0391 8.17115 10.8391 8.17193L10.2129 8.17075ZM10.6672 7.8731H10.7883C10.898 7.8731 10.977 7.84771 11.0246 7.79497C11.0723 7.74224 11.1027 7.65982 11.1137 7.54419C11.1171 7.5162 11.119 7.48802 11.1191 7.45982C11.1235 7.39566 11.1074 7.33177 11.073 7.27739C11.034 7.22388 10.9559 7.19693 10.8457 7.19693H10.7375L10.6672 7.8731ZM10.768 6.90981H10.8738C10.982 6.90981 11.0582 6.88599 11.1031 6.83911C11.148 6.79224 11.1754 6.7145 11.1867 6.60747C11.1867 6.5895 11.1891 6.57231 11.1891 6.5563C11.1921 6.5275 11.1883 6.49839 11.1782 6.47128C11.168 6.44417 11.1517 6.41978 11.1305 6.40005C11.0828 6.36099 11.0027 6.34419 10.8906 6.34419H10.8281L10.768 6.90981Z"
									/>
									<path
										d="M11.5947 8.1707L12.2338 6.05469H12.6936L12.8861 8.1707H12.4955L12.465 7.69844H12.124L11.9928 8.1707H11.5947ZM12.192 7.43438H12.4498L12.4107 6.58672L12.192 7.43438Z"
									/>
									<path
										d="M6.40332 10.659L6.62519 8.54302H7.15878C7.22857 8.54244 7.2983 8.54714 7.36738 8.55708C7.42665 8.56604 7.48437 8.58326 7.53886 8.60825C7.58912 8.63024 7.63353 8.66368 7.66855 8.70591C7.70384 8.75184 7.72804 8.80532 7.73925 8.86216C7.74815 8.90335 7.75247 8.9454 7.75214 8.98755C7.7521 9.02124 7.75002 9.05489 7.74589 9.08833C7.71568 9.34353 7.59693 9.48676 7.38964 9.51801C7.60683 9.55473 7.71529 9.6964 7.71503 9.94301C7.71503 9.97407 7.71333 10.0051 7.70995 10.036C7.68964 10.2425 7.62141 10.3976 7.50527 10.5012C7.38912 10.6049 7.23105 10.6569 7.03105 10.6575L6.40332 10.659ZM6.85761 10.3618H6.97871C7.0886 10.3618 7.16738 10.3357 7.21503 10.2836C7.26269 10.2316 7.29238 10.148 7.3041 10.0329C7.30743 10.005 7.30913 9.97694 7.30917 9.94887C7.31419 9.88467 7.29874 9.82054 7.26503 9.76567C7.22597 9.71215 7.14785 9.68559 7.03769 9.68559H6.92949L6.85761 10.3618ZM6.9584 9.39809H7.06425C7.17246 9.39809 7.24863 9.37465 7.29355 9.32739C7.33847 9.28012 7.36581 9.20278 7.37714 9.09575C7.37714 9.07778 7.37949 9.06098 7.37949 9.04458C7.37949 8.97153 7.35996 8.91958 7.32089 8.88833C7.27324 8.85083 7.19329 8.83208 7.08105 8.83208H7.01855L6.9584 9.39809Z"
									/>
									<path
										d="M7.90332 10.659L8.1248 8.54297H8.54316L8.32012 10.659H7.90332Z"
									/>
									<path
										d="M9.18223 10.6872C8.98665 10.6872 8.84629 10.6327 8.76113 10.5239C8.68887 10.4309 8.65215 10.2985 8.65137 10.1254C8.65137 10.095 8.65137 10.0626 8.65527 10.0286L9.02793 9.96216C9.02442 10.0012 9.02285 10.0364 9.02285 10.0696C9.02285 10.2662 9.08197 10.3644 9.2002 10.3641C9.22224 10.3655 9.2443 10.3617 9.26463 10.3531C9.28497 10.3445 9.30303 10.3313 9.31738 10.3145C9.34562 10.277 9.36268 10.2323 9.3666 10.1856C9.3666 10.1696 9.36895 10.154 9.36895 10.1395C9.36995 10.1011 9.3644 10.0628 9.35254 10.0262C9.33921 9.98261 9.31817 9.94173 9.29043 9.90552C9.25611 9.86378 9.21877 9.82461 9.17871 9.78834L8.96465 9.58287C8.89319 9.51758 8.83509 9.43904 8.79356 9.35162C8.76663 9.2857 8.75334 9.215 8.75449 9.14381C8.75464 9.11352 8.75647 9.08327 8.75996 9.05318C8.77741 8.88287 8.8416 8.75123 8.95254 8.65826C9.06348 8.56529 9.20671 8.51829 9.38223 8.51725H9.39082C9.46 8.51561 9.52889 8.52687 9.59395 8.55045C9.64669 8.56901 9.69451 8.59933 9.73379 8.63912C9.76868 8.678 9.79526 8.72359 9.81192 8.7731C9.83044 8.82349 9.84264 8.87597 9.84825 8.92935C9.85179 8.96491 9.85309 9.00066 9.85215 9.03639C9.85215 9.05709 9.85215 9.07857 9.85215 9.10162L9.48184 9.16177C9.48457 9.11842 9.48574 9.07818 9.48574 9.04185C9.48574 9.02467 9.48574 9.00748 9.48574 8.99068C9.48597 8.94755 9.47227 8.90549 9.44668 8.87076C9.43513 8.85724 9.42054 8.84666 9.40411 8.83987C9.38768 8.83308 9.36987 8.83028 9.35215 8.8317H9.34082C9.31786 8.83215 9.29523 8.8373 9.27433 8.84684C9.25343 8.85638 9.23472 8.87011 9.21934 8.88717C9.18843 8.9227 9.16968 8.96718 9.16582 9.01412C9.16424 9.02708 9.16346 9.04013 9.16348 9.05318C9.1632 9.0867 9.16875 9.12001 9.17988 9.15162C9.19095 9.18675 9.20786 9.21976 9.22988 9.24927C9.25592 9.28099 9.28397 9.311 9.31387 9.33912L9.52559 9.54224C9.56564 9.58078 9.60284 9.62216 9.63692 9.66607C9.66921 9.70887 9.69758 9.7545 9.72168 9.8024C9.7482 9.85545 9.76651 9.91221 9.77598 9.97076C9.78194 10.0063 9.78495 10.0422 9.78496 10.0782C9.78479 10.1072 9.78309 10.1361 9.77989 10.1649C9.76765 10.3106 9.69998 10.4461 9.59082 10.5434C9.47784 10.6415 9.33175 10.6929 9.18223 10.6872Z"
									/>
									<path
										d="M9.94824 10.659L10.1705 8.54297H10.5928L10.5021 9.41407H10.8877L10.9783 8.54375H11.4006L11.1787 10.6598H10.7561L10.8557 9.7168H10.4705L10.3709 10.6598L9.94824 10.659Z"
									/>
									<path
										d="M11.3877 10.659L12.0271 8.54297H12.4865L12.6791 10.659H12.2885L12.258 10.1867H11.9146L11.7857 10.659H11.3877ZM11.985 9.92188H12.2428L12.2037 9.07461L11.985 9.92188Z"
									/>
								</svg>
								<span>{{ jackpotSababisha.name[env.locale] }}</span>
							</router-link>
						</div>
						<div
							class="overlay-menu__nav__item"
							v-if="productAvailable('splitPot')"
						>
							<button
								class="overlay-menu__nav__button"
								@click="
									openRoute(
										`/${env.splitPotName.replace(/\s/, '-').toLowerCase()}`
									)
								"
								aria-pressed="true"
								aria-describedby="a11y__link-button--casino"
								:aria-label="env.splitPotName + ' icon'"
							>
								<svg
									class="overlay-menu__nav__icon"
									viewBox="0 0 20 20"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										d="M16.4092 24H7.59079C5.06015 24 3 21.8217 3 19.1405V4.85947C3 2.18072 5.06015 0 7.59079 0H16.4069C18.9376 0 20.9977 2.18072 20.9977 4.85947V19.1405C21 21.8217 18.9399 24 16.4092 24ZM7.59079 1.69235C5.94176 1.69235 4.59878 3.11393 4.59878 4.85947V19.1405C4.59878 20.8861 5.94176 22.3076 7.59079 22.3076H16.4069C18.056 22.3076 19.3989 20.8861 19.3989 19.1405V4.85947C19.3989 3.11393 18.056 1.69235 16.4069 1.69235H7.59079Z"
									/>
									<path
										d="M11.1264 15.9057C10.7724 15.9057 10.4161 15.8066 10.0918 15.6083C9.4454 15.2118 9.05713 14.5035 9.05713 13.7129V10.2895C9.05713 9.49894 9.44312 8.78815 10.0918 8.39408C10.7381 7.99758 11.5124 7.99758 12.1588 8.39408L14.9589 10.1058C15.6053 10.5023 15.9936 11.2106 15.9936 12.0012C15.9936 12.7918 15.6076 13.5026 14.9589 13.8966L12.1588 15.6083C11.8367 15.8066 11.4827 15.9057 11.1264 15.9057ZM11.131 9.5473C10.9688 9.5473 10.8432 9.61015 10.7792 9.64884C10.6742 9.71411 10.4298 9.90269 10.4298 10.2895V13.7129C10.4298 14.0973 10.6742 14.2883 10.7792 14.3536C10.8843 14.4189 11.163 14.547 11.4759 14.3536L14.276 12.6419C14.5912 12.4485 14.6255 12.1293 14.6255 12.0012C14.6255 11.8731 14.5912 11.5539 14.276 11.3605L11.4759 9.64884C11.3525 9.57389 11.2338 9.5473 11.131 9.5473Z"
									/>
								</svg>
								<span>{{ env.splitPotName }}</span>
							</button>
							<span
								id="a11y__link-button--casino"
								class="a11y__visually-hidden"
								aria-hidden="true"
								>{{ env.splitPotName }} link, opens a new tab.</span
							>
						</div>
						<div
							class="overlay-menu__nav__item"
							v-if="productAvailable('comet')"
						>
							<button
								class="overlay-menu__nav__button"
								@click="openRoute(`/comet-crash`)"
								aria-pressed="true"
								aria-describedby="a11y__link-button--casino"
								aria-label="Comet Crash icon"
							>
								<svg
									class="overlay-menu__nav__icon"
									xmlns="http://www.w3.org/2000/svg"
									viewBox="0 0 128 128"
								>
									<defs>
										<mask
											id="a"
											width="128"
											height="128"
											x="-1.04"
											y=".94"
											maskUnits="userSpaceOnUse"
										>
											<path
												fill="#fff"
												fill-rule="evenodd"
												d="M-1.04.94h128v128h-128V.94Z"
											/>
										</mask>
									</defs>
									<g mask="url(#a)">
										<path
											fill-rule="evenodd"
											d="M63.46 101.94c2.49 0 4.5 2.01 4.5 4.5s-2.01 4.5-4.5 4.5-4.5-2.01-4.5-4.5 2.01-4.5 4.5-4.5Zm.73-16.43c1.76 1.76 1.76 4.61 0 6.36L55 101.06c-1.76 1.76-4.61 1.76-6.36 0s-1.76-4.61 0-6.36l9.19-9.19c1.76-1.76 4.61-1.76 6.36 0Zm47.28-58.28c10.54 10.54 10.54 27.64 0 38.18-1.32 1.32-2.78 2.51-4.35 3.53l-31 31c-1.76 1.76-4.61 1.76-6.36 0s-1.76-4.61 0-6.36l20.35-20.35c-2.06-.17-4.09-.58-6.06-1.21l-9.06 9.06c-1.76 1.76-4.61 1.76-6.36 0s-1.76-4.61 0-6.36l7.11-7.12c-1.91-1.5-3.62-3.25-5.07-5.2L55.36 77.71c-1.78 1.74-4.63 1.7-6.36-.08-1.71-1.75-1.71-4.54 0-6.29l16.97-16.97c.16-.16.32-.3.5-.43-.6-2.04-.95-4.15-1.06-6.28L22.74 90.33c-1.76 1.76-4.61 1.76-6.36 0-1.76-1.76-1.76-4.61 0-6.36l54.45-54.45c.32-.32.68-.59 1.08-.8.44-.51.9-1 1.38-1.49 10.54-10.54 27.64-10.54 38.18 0Zm-17.3 1.35-4.11 1.44c-.12.02-.18.06-.3.09l-6.36 1.36c-.47.1-.92.32-1.24.68l-4.43 4.59c-.47.49-.69 1.1-.71 1.76l.1 4.03c.02.34-.07.65-.15.96l-1.67 4.24c-.21.56-.23 1.22 0 1.78l2.72 6.61c.23.56.71 1.02 1.25 1.27l4.63 1.87c.35.15.63.33.88.62l2.79 2.95c.51.58 1.2.87 1.94.78l7.54-.61c.29-.04.57-.07.84-.23l5.02-2.36 2.64-2.64 1.61-5.29c.07-.26.21-.56.39-.79l2.23-2.87c.43-.56.63-1.28.44-2l-1.43-6.66c-.05-.24-.16-.43-.26-.68l-3.1-5.42c-.18-.33-.45-.61-.77-.81l-3.78-2.37c-.09-.07-.19-.11-.3-.13l-4.68-2.1c-.54-.25-1.2-.26-1.76-.07Zm1.59 26.67c.71 1.24.28 2.8-.96 3.48-1.24.68-2.79.28-3.46-.9-.7-1.2-.3-2.75.91-3.45l.05-.03c1.24-.68 2.81-.33 3.46.9Zm-11.09-6.76c.6 1.06.24 2.38-.83 3.01s-2.43.27-2.99-.78c-.6-1.06-.24-2.38.83-3.01 1.07-.62 2.39-.28 2.99.78Zm20.25-.58c.56.97.22 2.18-.76 2.75s-2.18.26-2.74-.71-.18-2.17.76-2.75c.98-.57 2.18-.26 2.74.71Zm-10.36-4.77c.74 1.3.28 2.97-1.03 3.74-1.31.76-2.98.33-3.72-.97-.74-1.3-.28-2.97 1.03-3.74s2.98-.33 3.72.97Zm-8.78-6.9c.55.97.22 2.18-.76 2.74-.97.57-2.18.26-2.73-.71-.55-.97-.22-2.18.76-2.74.97-.57 2.18-.26 2.73.71Zm15.05-.3c.6 1.05.22 2.4-.83 3.01s-2.4.27-3-.78c-.6-1.04-.22-2.4.83-3.01 1.06-.62 2.4-.27 3 .78Zm-90.37 64c2.49 0 4.5-2.01 4.5-4.5s-2.01-4.5-4.5-4.5-4.5 2.01-4.5 4.5 2.01 4.5 4.5 4.5Z"
										/>
									</g>
									<path fill="none" d="M0 0h128v128H0z" />
								</svg>
								<span>Comet Crash</span>
							</button>
							<span
								id="a11y__link-button--casino"
								class="a11y__visually-hidden"
								aria-hidden="true"
								>Comet Crash link, opens a new tab.</span
							>
						</div>
						<div class="overlay-menu__nav__item">
							<button
								v-if="productAvailable('aviator')"
								class="overlay-menu__nav__button"
								@click="openRoute(`/aviator`)"
								aria-pressed="true"
								aria-describedby="a11y__link-button--casino"
								aria-label="Aviator icon"
							>
								<svg
									id="aviator"
									class="overlay-menu__nav__icon"
									data-name="Layer 1"
									xmlns="http://www.w3.org/2000/svg"
									viewBox="0 0 400.47 352.46"
								>
									<path
										class="cls-1"
										d="M412.3,334.53l-11.81,46.93a17.88,17.88,0,0,1-6.66,9.67,17.59,17.59,0,0,1-10.95,4l15.28-60.65h-18.9l-2,9.2-15.15,60.65h18.38q13.45,0,25.57-9.95T421.55,371l6.83-27.31,2.31-9.2H412.3Z"
										transform="translate(-279.25 -104.08)"
									/>
									<path
										class="cls-1"
										d="M446,388.32a5,5,0,0,1,.18-0.69,4.45,4.45,0,0,0,.17-0.55l13.15-52.54H429l-2.32,9.2h12.19L428,387.07a8.46,8.46,0,0,0-.4,1.66q-1.18,7.13,3.63,11.32t14.27,4.18h2.74l2.34-9.2C446.88,394.5,445.36,392.25,446,388.32Zm17.24-82.45a7.62,7.62,0,0,0-6.14-2.75,10.58,10.58,0,0,0-7,2.75,10.83,10.83,0,0,0-3.81,6.58,7.9,7.9,0,0,0,1.65,6.72,7.56,7.56,0,0,0,6.12,2.75,10.47,10.47,0,0,0,7.06-2.81,11.11,11.11,0,0,0,3.83-6.66A7.85,7.85,0,0,0,463.24,305.87Z"
										transform="translate(-279.25 -104.08)"
									/>
									<path
										class="cls-1"
										d="M513.78,390a2.53,2.53,0,0,1,.17-0.55,2.34,2.34,0,0,0,.15-0.54l13.58-54.34H496a33,33,0,0,0-18.41,5.57Q469.05,345.65,467,354l-7.66,30.74a9.09,9.09,0,0,0-.42,1.78,13,13,0,0,0,4.49,12.69q5.77,5,15.1,5h2.88a23.48,23.48,0,0,0,15.05-5.63q3.48,5.63,13.07,5.63H516l2.32-9.2Q513,394.76,513.78,390Zm-17.11-5.21a13.59,13.59,0,0,1-4.89,7.27,12.69,12.69,0,0,1-8,3c-5.3,0-7.53-2.55-6.7-7.69,0-.08.08-0.31,0.18-0.68a7.55,7.55,0,0,0,.2-0.83l8.81-35.26q1.8-6.85,7.57-6.86H507Z"
										transform="translate(-279.25 -104.08)"
									/>
									<path
										class="cls-1"
										d="M617,339.54q-5.7-5-15-5h-2.88a32.61,32.61,0,0,0-18.56,5.63q-8.4,5.63-10.43,13.85l-7.8,30.74a10.41,10.41,0,0,0-.42,1.78q-1.29,7.82,4.49,12.76t15.24,4.94h2.74a32.59,32.59,0,0,0,18.5-5.69q8.49-5.7,10.5-13.79L621.11,354l0.29-1.77A13.09,13.09,0,0,0,617,339.54Zm-14,13L602.72,354l-7.64,30.74a15.49,15.49,0,0,1-4,7.61A8.29,8.29,0,0,1,585.3,395a4.59,4.59,0,0,1-4.2-2.48,9.25,9.25,0,0,1-.82-6.3,5.07,5.07,0,0,1,.2-0.75,7.16,7.16,0,0,0,.18-0.75L588.31,354a16.36,16.36,0,0,1,3.81-7.33,8,8,0,0,1,6-2.81,4.58,4.58,0,0,1,4.15,2.26C603.17,347.64,603.43,349.77,603,352.5Z"
										transform="translate(-279.25 -104.08)"
									/>
									<path
										class="cls-1"
										d="M673.56,334.53a31.74,31.74,0,0,0-19.22,5.9l1.38-5.9h-18.3l-17.56,69.7h18.39l9.55-38.13A32.06,32.06,0,0,1,655,353a28.19,28.19,0,0,1,12-8.44l-2.18,9.06h10l4.9-19.08h-6.17Z"
										transform="translate(-279.25 -104.08)"
									/>
									<path
										class="cls-1"
										d="M364.66,308.32q-6.3-5.19-17-5.21a36.78,36.78,0,0,0-20.57,5.83,25.29,25.29,0,0,0-11.3,15.45l-7.64,30.3c-6.45,0-12.43,0-17.07,0a11.87,11.87,0,0,0-11.84,11.93h25.89l-9.44,37.58h18.23l9.47-37.58H340L334.12,390a8.83,8.83,0,0,0-.41,1.78c-0.65,3.94.12,7,2.34,9.2s5.53,3.28,10,3.28h7.28l2.34-9.2c-2.63-.18-3.73-1.6-3.28-4.23L369,324.39a8.5,8.5,0,0,1,.24-1.1,9.52,9.52,0,0,0,.24-1.12Q370.93,313.56,364.66,308.32ZM326.28,354.9l0-.21,8.43-32.91a12.63,12.63,0,0,1,3.91-6.81,9.81,9.81,0,0,1,6.69-2.66,5.85,5.85,0,0,1,5.12,2.34,7.72,7.72,0,0,1,1.1,5.89l-0.21,1.24-8.43,32.91-0.06.21H326.28Z"
										transform="translate(-279.25 -104.08)"
									/>
									<path
										class="cls-1"
										d="M561.79,334.53L566,318.35H547.57l-4,16.18h-9l-2.34,9.2h9l-11,43.49q0,0.28-.23,1a9.41,9.41,0,0,0-.22,1q-1.15,7,2.71,11t11.69,4h6.46L553,394.9q-5.67-.53-4.7-6.44a4.61,4.61,0,0,1,.18-0.69c0.08-.28.14-0.45,0.15-0.55l11-43.49h7.83l2.34-9.2h-8Z"
										transform="translate(-279.25 -104.08)"
									/>
									<polygon
										class="cls-1"
										points="266.98 106.33 226.47 98.47 266.97 82.2 274.91 91.43 266.98 106.33"
									/>
									<path
										class="cls-1"
										d="M359.48,283v0l0.06,0h-0.06Z"
										transform="translate(-279.25 -104.08)"
									/>
									<path
										class="cls-1"
										d="M599.74,189.58c-4.84-10.59-8.39-19.64-9.66-21.81-3.7-6.26-9.21-5.92-13.94-5.1-12.61,2.17-17.53,4.39-39.76,10.3-3.27.9-9.44,2.71-12.84,1.53-9-3.08-11.73-5.55-16.05-5.06-6.69.77-20.44,7.23-35.37,18.14-4.67,3.36-4.13,7.38-5,10a0.94,0.94,0,0,0,.8,1.21c2.17,0.22,25.86,2.28,26.94,2.43a1,1,0,0,1-.54-0.88,0.87,0.87,0,0,1,.49-0.8c6.76-3.64,31.32-16.65,46.15-22.5,20.29-8.05,25.19-8.91,31.35-9.49a36.38,36.38,0,0,1,4.93.06,3,3,0,0,1,2.62,1.93c2.8,8.22,11,26.79,15.34,32.94A3,3,0,0,1,593,204c-1.14,0-3.46-2.13-4.9-3.4a1,1,0,0,0-1.14-.07c-24.33,15-41.87,21.54-44.4,22.44a0.83,0.83,0,0,1-.64,0l-12.43-4.63a10.54,10.54,0,0,0,1.63-2.71,3.81,3.81,0,0,0,.35-1.55c-0.09-2-2-2.43-2.86-2.54-3.31-.41-92.12-13.51-114.39-15.7-9.45-1-18.44,3.89-22.33,9l0,0.13,12.61,13.14a0.92,0.92,0,0,0,1.07.21l9.92-4.57s1.36,4.2.09,4.91c-8.24,4.52-16.22,8.56-23.94,12.61-3.1,1.64-3,4.74-4,9.1-0.42,1.82-.64,3.49-0.64,3.49s17.3-8.67,27.9-13.73a1,1,0,0,1,1.08.21c1.51,1.63,2,2,3,3a0.94,0.94,0,0,1-.22,1.49c-2.5,1.33-5.08,2.69-7.06,3.87-1.57.93,0,4.06,0,4.06l28.79-13.64s1.79,1.77-1.38,3.74c-4.91,3.08-50.32,26.23-54.22,26.33-10.3.26-29.73-19.12-36.75-22.07-5.92-2.49-12.3,1.57-20.95,6.65-2.35,1.4-.92,4.78-0.92,4.78l12.54-6.35s1.55,1.79-.19,2.88c-6.07,3.85-14.85,7.7-16.2,8.67-2,1.42-1.22,8.07-1.22,8.07l11.86-5.5a1,1,0,0,1,1,.06l25.42,24.2a28.49,28.49,0,0,0,4.71-1.59l-21.21-22.55a1,1,0,0,1,.26-1.49c2.17-1.1,4.76-1.91,8.43.9,3.08,2.34,13.86,11.06,24.29,10.13,3.48-.3,3.53.77,3.53,0.77s-4.43,2.13-9.68,5c-2.6,1.44-.49,5.23-0.49,5.23,26.87-11,60-24.74,64.6-26.74a1,1,0,0,1,1,.13l7.77,6.17c1.1,1.72,56.37-19.53,73.41-28.14,1-.47,9.62-0.07,13.81-0.11,1.92,0,1.85.84,1.85,0.84S393.47,284.26,359.54,283l-0.06,0-7.23,3.1c4.24,2.8,3.23,7.64,10.45,3.9,0.43,1,.93,2,1.46,3.16,1.4,3,1.4,3.06,10.58-.06,26-8.78,142.68-43.67,168.82-54.49,14.76-6.09,35.17-14.5,47.89-22.38C604,208.51,606.56,204.51,599.74,189.58Zm-111.67.54c-1.57,1.12-11.91-.81-11.91-0.81s11.44-10.17,22.33-11.47c3.24-.39,9.79,2.15,9.79,2.15S493.67,186.09,488.07,190.12ZM522.77,180L508,187.58s-3.42-2.07.43-3.81c1-.45,3.25-1.74,5.08-2.69a1.34,1.34,0,0,0-.13-2.43l-10.95-4.39a8.42,8.42,0,0,1,7.47-1.53c1.59,0.49,8.24,3.29,12.61,5.12A1.15,1.15,0,0,1,522.77,180Zm3.68,35.73c-1.44,2.13-4.8,6.09-9.74,5.29-2.41-.41-100.49-20.31-100.73-20.33-0.69-.19-0.6-1.66.65-1.51L525.8,214.26A1,1,0,0,1,526.45,215.76Z"
										transform="translate(-279.25 -104.08)"
									/>
									<path
										class="cls-1"
										d="M597.33,171a1.77,1.77,0,0,0-.3.07,0.78,0.78,0,0,0-.26.17l1-.26Z"
										transform="translate(-279.25 -104.08)"
									/>
									<path
										class="cls-1"
										d="M637.65,244.74c-0.82-3.29-6.84-25.09-10.31-33.09l-15.85-28.44a45.11,45.11,0,0,1-5,5.81,5,5,0,0,1-1,.67A4.12,4.12,0,0,1,604,190l8.54,28c1.27,4.5,4.24,8.33,6.8,12.22,1.29,1.92,10.37,15.47,13.86,20.67a1.84,1.84,0,0,0,3.06,0A8.17,8.17,0,0,0,637.65,244.74Zm-3.1,3.89-0.19.3-0.21-.3c-0.13-.19-12.95-19.06-17.58-26.37-1.4-2.2.24-3.31,0.24-3.31l0.19-.11,0.13,0.17c0.65,0.82,15.77,20.52,17.73,24.14A5.56,5.56,0,0,1,634.55,248.63Z"
										transform="translate(-279.25 -104.08)"
									/>
									<path
										class="cls-1"
										d="M595.59,139.36c-1.74-5.89-4.71-9.7-7.29-13.6-1.29-2-10.73-16-14.05-21a1.57,1.57,0,0,0-2.62,0,8.68,8.68,0,0,0-1.44,6.65c0.84,3.27,6.65,25,10.13,33l14.46,25.47a3.94,3.94,0,0,1,1.31-1,3.29,3.29,0,0,1,1.08-.26c1.91-.13,4.9-0.11,7.6-0.06Zm-4.67-2-0.19.11-0.13-.17c-0.64-.84-15.73-20.52-17.73-24.16a5.63,5.63,0,0,1,.34-5.47l0.19-.28,0.21,0.28c0.13,0.21,13,19.1,17.58,26.38C592.58,136.29,590.94,137.37,590.92,137.39Z"
										transform="translate(-279.25 -104.08)"
									/>
									<path
										class="cls-1"
										d="M613.53,171c-3.94-.88-11.4-0.93-15.86-0.65a4.14,4.14,0,0,0-.49,0,2.62,2.62,0,0,0-.32.07,0.82,0.82,0,0,0-.28.19,1.53,1.53,0,0,0-.6,1.66c2.24,5.66,4.22,10.05,6.82,15.21a1.59,1.59,0,0,0,2,.5,2.16,2.16,0,0,0,.41-0.26,44.45,44.45,0,0,0,9.66-13.57C615.6,172.58,615.17,171.34,613.53,171Zm-12.95,7.66-2.28-5.25a0.85,0.85,0,0,1,.52-1.2,1,1,0,0,1,.24-0.09s9.44-.34,12.39.24c1.57,0.32,1.63.88,1.63,0.88Z"
										transform="translate(-279.25 -104.08)"
									/>
									<path
										class="cls-1"
										d="M565.47,172.43s-1.78,7.37-4.59,15.87l-5.2-6.57-4.21,1.92,7.66,9.7c-2.39,6.54-5.27,13.05-8.34,16.89l7.68-3.49c1.75-1.62,3.16-4.9,4.26-8.84l4.22,5.34,4.24-1.93-7.16-9C565.59,184.11,566,175.22,565.47,172.43Z"
										transform="translate(-279.25 -104.08)"
									/>
									<rect
										class="cls-1"
										x="140.27"
										y="322.79"
										width="119.94"
										height="10"
										rx="5"
										ry="5"
									/>
									<rect
										class="cls-1"
										x="160.27"
										y="342.46"
										width="79.94"
										height="10"
										rx="5"
										ry="5"
									/>
								</svg>
								<span>Aviator</span>
							</button>
							<span
								id="a11y__link-button--casino"
								class="a11y__visually-hidden"
								aria-hidden="true"
								>Aviator link, opens a new tab.</span
							>
						</div>
						<div
							class="overlay-menu__nav__item"
							v-if="productAvailable('shikisha')"
						>
							<button
								class="overlay-menu__nav__button"
								@click="
									openRoute(
										`/${env.shikishaProductName
											.replace(/\s/, '-')
											.toLowerCase()}`
									)
								"
								aria-pressed="true"
								aria-describedby="a11y__link-button--shikisha-bet"
								:aria-label="env.shikishaProductName + ' icon'"
							>
								<svg
									class="overlay-menu__nav__icon"
									viewBox="0 0 20 20"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										d="M19.2975 15.0688C18.3933 14.2656 17.389 13.5829 16.3096 13.0376C16.1456 13.3048 15.9648 13.5613 15.7682 13.8055C15.5377 13.6919 15.3049 13.5825 15.065 13.4817C13.4426 12.7985 11.7 12.4465 9.93965 12.4465C8.17927 12.4465 6.43665 12.7985 4.81426 13.4817C4.57676 13.5821 4.34551 13.6911 4.11465 13.8051C3.91881 13.5612 3.73851 13.3053 3.5748 13.0387C2.49542 13.5841 1.49113 14.2669 0.586914 15.07L2.35449 15.2083L2.10645 16.9922C2.88623 16.2846 3.75804 15.6856 4.69824 15.2114L5.18418 16.0016C6.66317 15.2696 8.29116 14.8887 9.94141 14.8887C11.5917 14.8887 13.2196 15.2696 14.6986 16.0016L15.1854 15.2106C16.1261 15.685 16.9984 16.2843 17.7787 16.9922L17.5303 15.209L19.2975 15.0688Z"
									/>
									<path
										d="M2.83203 9.20156C2.83203 9.65859 3.41797 10.0512 3.50391 10.4828C3.59141 10.9273 3.20156 11.5141 3.37109 11.9234C3.54063 12.3328 4.23047 12.4773 4.48047 12.8445L4.53516 12.8199C4.88906 12.6703 5.24922 12.5395 5.61211 12.4203C4.91779 11.4909 4.54323 10.3617 4.54453 9.20156C4.54453 6.22578 6.96641 3.8043 9.9418 3.8043C12.9172 3.8043 15.3391 6.22617 15.3391 9.20156C15.3405 10.3622 14.9658 11.4921 14.2711 12.4219C14.6336 12.5391 14.9926 12.6719 15.3469 12.8211L15.402 12.8461C15.6523 12.4785 16.3395 12.3383 16.5121 11.9246C16.6848 11.5109 16.2918 10.9285 16.3801 10.484C16.4652 10.0523 17.052 9.65977 17.052 9.20273C17.052 8.7457 16.466 8.35352 16.3801 7.92188C16.2918 7.47734 16.6816 6.89023 16.5121 6.48125C16.3395 6.06523 15.6473 5.92656 15.3996 5.55703C15.152 5.1875 15.2855 4.49141 14.9699 4.17578C14.6543 3.86016 13.9613 3.99492 13.5891 3.74609C13.2168 3.49727 13.0812 2.80625 12.6641 2.6332C12.2543 2.46094 11.6676 2.85156 11.223 2.76367C10.7914 2.67813 10.3984 2.0918 9.9418 2.0918C9.48516 2.0918 9.09219 2.67773 8.66055 2.76367C8.21602 2.85156 7.62891 2.46094 7.21992 2.63125C6.80391 2.80391 6.66523 3.49609 6.2957 3.74414C5.92617 3.99219 5.23008 3.8582 4.91445 4.17383C4.59883 4.48945 4.73359 5.18203 4.48477 5.55469C4.23594 5.92734 3.54492 6.0625 3.37266 6.47969C3.20234 6.88867 3.59219 7.47578 3.50469 7.92031C3.41797 8.35234 2.83203 8.74531 2.83203 9.20156Z"
									/>
									<path
										d="M7.28496 17.3512L7.24238 16.9079L6.85254 16.6899L7.2627 16.5098L7.3502 16.0696L7.64668 16.409L8.08926 16.3559L7.8627 16.7395L8.05098 17.145L7.61191 17.0508L7.28496 17.3512Z"
									/>
									<path
										d="M10.1125 17.8976L9.92422 17.4925L9.48242 17.4218L9.80469 17.1136L9.73711 16.6733L10.1285 16.8851L10.5313 16.6823L10.45 17.1249L10.7664 17.4425L10.3195 17.4979L10.1125 17.8976Z"
									/>
									<path
										d="M12.9604 17.4398L12.642 17.1285L12.2006 17.2133L12.4014 16.8117L12.1865 16.416L12.6283 16.4867L12.935 16.1602L13.0092 16.602L13.4146 16.7898L13.0143 16.9969L12.9604 17.4398Z"
									/>
									<path
										d="M12.5254 6.53027H7.68555C7.41588 6.53027 7.19727 6.74888 7.19727 7.01855V7.21465C7.19727 7.48432 7.41588 7.70293 7.68555 7.70293H12.5254C12.7951 7.70293 13.0137 7.48432 13.0137 7.21465V7.01855C13.0137 6.74888 12.7951 6.53027 12.5254 6.53027Z"
									/>
									<path
										d="M9.61719 8.17163H7.68555C7.41588 8.17163 7.19727 8.39024 7.19727 8.65991V8.85601C7.19727 9.12568 7.41588 9.34429 7.68555 9.34429H9.61719C9.88686 9.34429 10.1055 9.12568 10.1055 8.85601V8.65991C10.1055 8.39024 9.88686 8.17163 9.61719 8.17163Z"
									/>
									<path
										d="M11.3059 9.81323H7.68555C7.41588 9.81323 7.19727 10.0318 7.19727 10.3015V10.4976C7.19727 10.7673 7.41588 10.9859 7.68555 10.9859H11.3059C11.5755 10.9859 11.7941 10.7673 11.7941 10.4976V10.3015C11.7941 10.0318 11.5755 9.81323 11.3059 9.81323Z"
									/>
								</svg>
								<span>{{ env.shikishaProductName }}</span>
							</button>
							<span
								id="a11y__link-button--shikisha-bet"
								class="a11y__visually-hidden"
								aria-hidden="true"
								>{{ env.shikishaProductName }} link, opens a new tab.</span
							>
						</div>
						<div
							class="overlay-menu__nav__item"
							v-if="productAvailable('goldenRace')"
						>
							<button
								class="overlay-menu__nav__button"
								@click="openRoute('/betika-super-league')"
								aria-pressed="true"
								aria-describedby="a11y__link-button--betika-super-league"
								:aria-label="$t('nav.super-league') + ' icon'"
							>
								<svg
									class="overlay-menu__nav__icon"
									viewBox="0 0 20 20"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										d="M11.4072 20H4.68848C2.10379 20 0.000976562 17.8972 0.000976562 15.3125V3.90625C0.000976562 1.75234 1.75332 0 3.90723 0C3.90723 0 17.4373 0.00136719 17.4636 0.00402344C18.8951 0.0652344 19.9995 1.20902 19.9995 2.65828V3.66191C19.9995 4.71973 19.4373 5.67629 18.5322 6.15828C18.1514 6.36113 17.6783 6.21688 17.4754 5.83598C17.2726 5.45516 17.4169 4.98203 17.7977 4.77918C18.192 4.56918 18.437 4.14105 18.437 3.66188V2.65828C18.3923 1.09664 16.1102 1.29539 16.0947 2.73438V15.3125C16.0947 17.8972 13.9919 20 11.4072 20ZM3.90723 1.5625C2.61488 1.5625 1.56348 2.61391 1.56348 3.90625V15.3125C1.56348 17.0356 2.96535 18.4375 4.68848 18.4375H11.4072C13.1304 18.4375 14.5322 17.0356 14.5322 15.3125V2.73438C14.5322 2.32055 14.6239 1.9227 14.7978 1.5625H3.90723ZM12.9697 4.29688C12.9697 3.86539 12.62 3.51562 12.1885 3.51562H3.90723C2.87066 3.55687 2.87145 5.03723 3.90723 5.07812H12.1885C12.6199 5.07812 12.9697 4.72836 12.9697 4.29688ZM12.9697 7.42188C12.9697 6.99039 12.62 6.64062 12.1885 6.64062H9.61035C8.57379 6.68188 8.57457 8.16223 9.61035 8.20312H12.1885C12.6199 8.20312 12.9697 7.85336 12.9697 7.42188ZM7.2666 7.42188C7.2666 6.99039 6.91684 6.64062 6.48535 6.64062H3.90723C2.87066 6.68188 2.87145 8.16223 3.90723 8.20312H6.48535C6.9168 8.20312 7.2666 7.85336 7.2666 7.42188ZM9.56629 16.8752C9.33324 16.8752 9.09899 16.8196 8.88199 16.707L8.08688 16.2945L7.29176 16.707C6.78813 16.9684 6.19109 16.9225 5.73363 16.5875C5.28121 16.2561 5.05965 15.7083 5.15531 15.1578L5.30477 14.2979L4.66969 13.687C4.26356 13.2963 4.11832 12.7213 4.2907 12.1864C4.46426 11.6479 4.92188 11.2632 5.485 11.1824L6.37129 11.0554L6.76574 10.2666C7.29293 9.18742 8.88098 9.18777 9.40793 10.2666L9.80238 11.0554L10.6887 11.1824C11.2518 11.2632 11.7094 11.6479 11.883 12.1864C12.0554 12.7213 11.9102 13.2963 11.504 13.687L10.8689 14.2979L11.0184 15.1578C11.114 15.7083 10.8924 16.2561 10.44 16.5875C10.1798 16.7782 9.87414 16.8752 9.56629 16.8752ZM5.89914 12.7016L6.4259 13.2083C6.77684 13.5459 6.93676 14.0329 6.85363 14.5113L6.72699 15.2398L7.40414 14.8885C7.8316 14.6667 8.34207 14.6667 8.76957 14.8885L9.44672 15.2398L9.32008 14.5113C9.23695 14.0329 9.39684 13.5459 9.74781 13.2083L10.2746 12.7016L9.5368 12.5958C9.05719 12.5271 8.64207 12.2286 8.42641 11.7973L8.08684 11.1184L7.74727 11.7973C7.5316 12.2286 7.11649 12.5271 6.63684 12.5958L5.89914 12.7016Z"
									/>
								</svg>
								<span>{{ $t("nav.super-league") }}</span>
							</button>
							<span
								id="a11y__link-button--betika-super-league"
								class="a11y__visually-hidden"
								aria-hidden="true"
								>{{ $t("nav.super-league") }} link, opens a new tab.</span
							>
							<div
								style="
									display: flex;
									flex-direction: column;
									align-items: start;
									padding: 10px 0;
									margin-left: 28px;
								"
							>
								<div
									class="overlay-menu__nav__item super"
									v-for="link in env.goldenRaceDeeplinks"
									:key="link.ref"
								>
									<button
										class="overlay-menu__nav__button"
										@click="openRoute(`/betika-super-league?ref=${link.ref}`)"
										aria-pressed="true"
										aria-describedby="a11y__link-button--live-games"
										:aria-label="link.name + ' icon'"
										Icon
									>
										<img
											:src="`${link.logoUrl}`"
											style="width: 20px; height: 20px; margin-right: 10px"
										/>
										<span>{{ link.name }}</span>
									</button>
									<span
										id="a11y__link-button--live-games"
										class="a11y__visually-hidden"
										aria-hidden="true"
										>{{ link.name }} link, opens a new tab.</span
									>
								</div>
							</div>
						</div>
						<div class="overlay-menu__line"></div>
						<div
							class="overlay-menu__nav__item"
							v-if="productAvailable('livescore')"
						>
							<button
								class="overlay-menu__nav__button"
								@click="openRoute('/livescore')"
								aria-pressed="true"
								aria-describedby="a11y__link-button--live-score"
								:aria-label="$t('nav.live-score') + ' icon'"
							>
								<svg
									class="overlay-menu__nav__icon"
									viewBox="0 0 20 20"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										d="M11.6664 15C11.3826 15 11.1008 15.0481 10.8331 15.1425V15C10.8331 14.7789 10.9209 14.567 11.0772 14.4107C11.2334 14.2544 11.4454 14.1666 11.6664 14.1666C11.7848 14.1659 11.902 14.1907 12.0098 14.2395C12.1177 14.2882 12.2138 14.3598 12.2914 14.4491C12.3629 14.5342 12.4506 14.6042 12.5495 14.6549C12.6484 14.7056 12.7564 14.736 12.8672 14.7443C12.978 14.7527 13.0894 14.7387 13.1947 14.7034C13.3001 14.668 13.3973 14.612 13.4807 14.5385C13.564 14.465 13.6319 14.3756 13.6802 14.2756C13.7285 14.1755 13.7563 14.0668 13.7619 13.9558C13.7676 13.8448 13.751 13.7338 13.7131 13.6293C13.6753 13.5249 13.6169 13.429 13.5414 13.3475C13.2056 12.9667 12.7618 12.6972 12.2691 12.5748C11.7763 12.4524 11.258 12.4829 10.783 12.6623C10.3081 12.8417 9.89901 13.1615 9.61023 13.5791C9.32144 13.9966 9.16664 14.4922 9.16642 15V17.5C9.1666 18.0427 9.34342 18.5707 9.67017 19.0041C9.99692 19.4375 10.4558 19.7528 10.9776 19.9024C11.4994 20.0519 12.0557 20.0276 12.5624 19.8331C13.0691 19.6386 13.4988 19.2844 13.7864 18.8241C14.0185 18.4505 14.1497 18.0231 14.1674 17.5837C14.1851 17.1442 14.0885 16.7077 13.8873 16.3166C13.6762 15.9123 13.3565 15.5749 12.9642 15.3423C12.5719 15.1097 12.1224 14.9911 11.6664 15ZM12.3739 17.9408C12.2972 18.0639 12.1896 18.1648 12.0619 18.2336C11.9342 18.3024 11.7907 18.3367 11.6457 18.333C11.5007 18.3294 11.3591 18.2879 11.235 18.2127C11.1109 18.1376 11.0086 18.0313 10.9382 17.9045C10.8678 17.7777 10.8317 17.6346 10.8335 17.4896C10.8353 17.3445 10.8749 17.2024 10.9485 17.0774C11.022 16.9524 11.127 16.8487 11.2529 16.7767C11.3788 16.7046 11.5213 16.6667 11.6664 16.6666C11.8097 16.6588 11.9525 16.6899 12.0796 16.7567C12.2066 16.8234 12.3132 16.9233 12.3881 17.0458C12.465 17.1829 12.5042 17.338 12.5017 17.4952C12.4992 17.6524 12.4551 17.8062 12.3739 17.9408ZM17.4998 12.5C16.8367 12.5 16.2008 12.7634 15.732 13.2322C15.2631 13.701 14.9998 14.3369 14.9998 15V17.5C14.9998 18.163 15.2631 18.7989 15.732 19.2677C16.2008 19.7366 16.8367 20 17.4998 20C18.1628 20 18.7987 19.7366 19.2675 19.2677C19.7364 18.7989 19.9998 18.163 19.9998 17.5V15C19.9998 14.3369 19.7364 13.701 19.2675 13.2322C18.7987 12.7634 18.1628 12.5 17.4998 12.5ZM18.3331 17.5C18.3331 17.721 18.2453 17.9329 18.089 18.0892C17.9327 18.2455 17.7208 18.3333 17.4998 18.3333C17.2787 18.3333 17.0668 18.2455 16.9105 18.0892C16.7542 17.9329 16.6664 17.721 16.6664 17.5V15C16.6664 14.7789 16.7542 14.567 16.9105 14.4107C17.0668 14.2544 17.2787 14.1666 17.4998 14.1666C17.7208 14.1666 17.9327 14.2544 18.089 14.4107C18.2453 14.567 18.3331 14.7789 18.3331 15V17.5ZM9.99975 10.8333H6.66642C6.44541 10.8333 6.23345 10.7455 6.07716 10.5892C5.92088 10.4329 5.83309 10.221 5.83309 9.99996C5.83309 9.77894 5.92088 9.56698 6.07716 9.4107C6.23345 9.25442 6.44541 9.16663 6.66642 9.16663H9.16642V5.83329C9.16642 5.61228 9.25422 5.40032 9.4105 5.24404C9.56678 5.08776 9.77874 4.99996 9.99975 4.99996C10.2208 4.99996 10.4327 5.08776 10.589 5.24404C10.7453 5.40032 10.8331 5.61228 10.8331 5.83329V9.99996C10.8331 10.221 10.7453 10.4329 10.589 10.5892C10.4327 10.7455 10.2208 10.8333 9.99975 10.8333ZM19.9998 2.49996V4.99996C19.9998 5.663 19.7364 6.29889 19.2675 6.76773C18.7987 7.23657 18.1628 7.49996 17.4998 7.49996H14.9998C14.7787 7.49996 14.5668 7.41216 14.4105 7.25588C14.2542 7.0996 14.1664 6.88764 14.1664 6.66663C14.1664 6.44561 14.2542 6.23365 14.4105 6.07737C14.5668 5.92109 14.7787 5.83329 14.9998 5.83329H17.1973C16.5305 4.68257 15.5977 3.70832 14.4771 2.99212C13.3564 2.27592 12.0805 1.83859 10.7561 1.71677C9.43177 1.59494 8.09749 1.79214 6.86499 2.29188C5.63249 2.79162 4.53765 3.57934 3.6721 4.5891C2.80656 5.59887 2.19551 6.80129 1.89011 8.09571C1.58471 9.39012 1.59384 10.7389 1.91674 12.029C2.23964 13.3192 2.86692 14.5132 3.74605 15.5112C4.62519 16.5091 5.7306 17.282 6.96975 17.765C7.17574 17.8454 7.34133 18.0044 7.4301 18.2069C7.51886 18.4095 7.52354 18.639 7.44309 18.845C7.36264 19.0509 7.20366 19.2165 7.00112 19.3053C6.79858 19.3941 6.56907 19.3987 6.36309 19.3183C4.89863 18.7471 3.58947 17.8386 2.54182 16.6667C1.49417 15.4948 0.737544 14.0924 0.333336 12.5734C-0.070872 11.0543 -0.111277 9.46136 0.215398 7.92376C0.542074 6.38616 1.22663 4.94722 2.21352 3.72371C3.20041 2.5002 4.46183 1.52657 5.89545 0.881829C7.32906 0.237086 8.89447 -0.0606106 10.4647 0.0128928C12.0349 0.0863962 13.5656 0.52903 14.9327 1.30488C16.2999 2.08073 17.4648 3.16794 18.3331 4.47829V2.49996C18.3331 2.27895 18.4209 2.06698 18.5772 1.9107C18.7334 1.75442 18.9454 1.66663 19.1664 1.66663C19.3874 1.66663 19.5994 1.75442 19.7557 1.9107C19.912 2.06698 19.9998 2.27895 19.9998 2.49996Z"
									/>
								</svg>
								<span>{{ $t("nav.live-score") }}</span>
							</button>
							<span
								id="a11y__link-button--live-score"
								class="a11y__visually-hidden"
								aria-hidden="true"
								>{{ $t("nav.live-score") }} link, opens a new window.</span
							>
						</div>
						<div
							class="overlay-menu__nav__item"
							v-if="featureAvailable('appLink')"
						>
							<a
								class="button link no-bg help__action"
								aria-describedby="a11y__link-button--download-app"
								:aria-label="$t('general.download-app') + ' icon'"
								:href="env.appLink"
								target="_black"
							>
								<svg
									class="overlay-menu__nav__icon"
									viewBox="0 0 20 20"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										d="M12.3438 20H7.65625C5.50234 20 3.75 18.2477 3.75 16.0938V3.90625C3.75 1.75234 5.50234 0 7.65625 0H12.3438C14.4977 0 16.25 1.75234 16.25 3.90625V16.0938C16.25 18.2477 14.4977 20 12.3438 20ZM7.65625 1.5625C6.36391 1.5625 5.3125 2.61391 5.3125 3.90625V16.0938C5.3125 17.3861 6.36391 18.4375 7.65625 18.4375H12.3438C13.6361 18.4375 14.6875 17.3861 14.6875 16.0938V3.90625C14.6875 2.61391 13.6361 1.5625 12.3438 1.5625H7.65625Z"
									/>
									<path
										d="M10.7812 16.875H9.21875C8.78727 16.875 8.4375 16.5252 8.4375 16.0938C8.4375 15.6623 8.78727 15.3125 9.21875 15.3125H10.7812C11.2127 15.3125 11.5625 15.6623 11.5625 16.0938C11.5625 16.5252 11.2127 16.875 10.7812 16.875Z"
									/>
									<path
										d="M10.7812 4.6875H9.21875C8.78727 4.6875 8.4375 4.33773 8.4375 3.90625C8.4375 3.47477 8.78727 3.125 9.21875 3.125H10.7812C11.2127 3.125 11.5625 3.47477 11.5625 3.90625C11.5625 4.33773 11.2127 4.6875 10.7812 4.6875Z"
									/>
								</svg>
								{{ $t("general.download-app") }}
							</a>
							<span
								id="a11y__link-button--download-app"
								class="a11y__visually-hidden"
								aria-hidden="true"
								>{{ $t("general.download-app") }} link, opens a new
								window.</span
							>
						</div>
						<div
							class="overlay-menu__nav__item"
							v-if="productAvailable('offersNRewards')"
						>
							<button
								class="overlay-menu__nav__button"
								@click="openRoute('/promotions')"
								aria-pressed="true"
								aria-describedby="a11y__link-button--offers-rewards"
								:aria-label="$t('legal.promotions') + ' icon'"
							>
								<svg
									class="overlay-menu__nav__icon"
									viewBox="0 0 18 18"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										fill-rule="evenodd"
										clip-rule="evenodd"
										d="M15.9996 6.62147L16.5999 7.22147C17.075 7.68814 17.3335 8.32147 17.3335 8.98814C17.3418 9.65481 17.0834 10.289 16.6165 10.7631C16.611 10.7693 16.6054 10.7746 16.5999 10.78C16.5971 10.7827 16.5943 10.7854 16.5915 10.7881L15.9996 11.3798C15.7662 11.6131 15.6328 11.9298 15.6328 12.264V13.1215C15.6328 14.5048 14.5074 15.6306 13.1236 15.6306H12.265C11.9315 15.6306 11.6147 15.7631 11.3813 15.9965L10.7811 16.5965C10.2892 17.089 9.64734 17.3298 9.00544 17.3298C8.36354 17.3298 7.72164 17.089 7.2298 16.6056L6.62125 15.9965C6.38783 15.7631 6.07105 15.6306 5.73759 15.6306H4.87895C3.49511 15.6306 2.36971 14.5048 2.36971 13.1215V12.264C2.36971 11.9298 2.23632 11.6131 2.00291 11.3715L1.40269 10.7798C0.427335 9.80564 0.418999 8.21314 1.39435 7.23064L2.00291 6.62147C2.23632 6.38814 2.36971 6.07147 2.36971 5.72981V4.87981C2.36971 3.49647 3.49511 2.37231 4.87895 2.37231H5.73759C6.07105 2.37231 6.38783 2.23814 6.62125 2.00481L7.22146 1.40481C8.19682 0.422307 9.78906 0.422307 10.7727 1.39731L11.3813 2.00481C11.6147 2.23814 11.9315 2.37231 12.265 2.37231H13.1236C14.5074 2.37231 15.6328 3.49647 15.6328 4.87981V5.73897C15.6328 6.07147 15.7662 6.38814 15.9996 6.62147ZM6.85467 11.8715C7.05474 11.8715 7.23814 11.7965 7.37152 11.6548L11.6564 7.37231C11.9398 7.08897 11.9398 6.62147 11.6564 6.33814C11.373 6.05564 10.9145 6.05564 10.631 6.33814L6.34615 10.6215C6.06271 10.9048 6.06271 11.3715 6.34615 11.6548C6.47953 11.7965 6.66293 11.8715 6.85467 11.8715ZM10.4143 11.1381C10.4143 11.5465 10.7394 11.8715 11.1479 11.8715C11.548 11.8715 11.8732 11.5465 11.8732 11.1381C11.8732 10.739 11.548 10.4131 11.1479 10.4131C10.7394 10.4131 10.4143 10.739 10.4143 11.1381ZM6.863 6.12981C7.26315 6.12981 7.58826 6.45481 7.58826 6.85481C7.58826 7.26397 7.26315 7.58814 6.863 7.58814C6.46286 7.58814 6.1294 7.26397 6.1294 6.85481C6.1294 6.45481 6.46286 6.12981 6.863 6.12981Z"
									/>
								</svg>
								<span>{{ $t("legal.promotions") }}</span>
								<div class="badge badge-warning">
									{{ $t("overlay-menu.new") }}
								</div>
							</button>
							<span
								id="a11y__link-button--offers-rewards"
								class="a11y__visually-hidden"
								aria-hidden="true"
								>{{ $t("legal.promotions") }} link, opens a new tab.</span
							>
						</div>
					</div>
				</div>
			</div>
			<div class="overlay-menu__section">
				<div class="overlay-menu__section__header main">
					<h3>{{ $t("overlay-menu.preferences") }}</h3>
					<p>{{ $t("overlay-menu.customise-your-experience") }}</p>
				</div>
				<div class="overlay-menu__strocked-card">
					<theme-switcher />
					<auto-refresh-switcher />
					<!-- <recommendation /> -->
				</div>
			</div>
			<div class="overlay-menu__section">
				<div class="overlay-menu__section__header main">
					<h3>{{ $t("overlay-menu.get-help") }}</h3>
					<p>{{ $t("overlay-menu.quick-help") }}</p>
				</div>
				<div class="overlay-menu__strocked-card">
					<help />
					<div
						v-if="env.availableFeatures.zendeskChat && env.zendeskChat.enabled && $store.getters.layout == 'Mobile'"
						@click="liveChat"
					>
						<HelpAction
							:icon="'DeviceMessageIcon'"
							:text="this.$t('overlay-menu.live-chat')"
							:has-caret="false"
							:show="true"
						/>
					</div>
				</div>
			</div>
			<div
				class="overlay-menu__section"
				v-if="env.availableFeatures.affiliates"
			>
				<div>
					<div class="overlay-menu__section__header main">
						<h3 class="account__section__title">
							{{ $t("overlay-menu.affiliates") }}
						</h3>
					</div>
					<a
						class="account_section button link no-bg no-padding full"
						:href="env.affiliatesLink"
						target="_blank"
					>
						<div class="overlay-menu__strocked-card">
							<p class="account__section__desc">
								{{ $t("overlay-menu.become-an-affiliate") }}
								<!-- (T&Cs, Privacy Policy, et al.) -->
							</p>
						</div>
					</a>
				</div>
			</div>
			<div
				class="overlay-menu__section"
				v-if="
					env.availableFeatures.referAndChop &&
					env.betikaAffiliates.routePath !== null
				"
			>
				<div>
					<div class="overlay-menu__section__header main">
						<h3 class="account__section__title">
							{{ $t("account.affiliate-program.refer-and-chop") }}
						</h3>
					</div>
					<a
						class="account_section button link no-bg no-padding full"
						@click="openRoute(env.betikaAffiliates.routePath)"
						target="_blank"
					>
						<div class="overlay-menu__strocked-card">
							<p class="account__section__desc">
								{{ $t("account.affiliate-program.refer-and-chop") }}
							</p>
						</div>
					</a>
				</div>
			</div>
			<div class="overlay-menu__section">
				<div v-if="env.termsLinkType == 'external'">
					<div class="overlay-menu__section__header main">
						<h3 class="account__section__title"><!-- Legal -->T&Cs</h3>
					</div>
					<a
						class="account_section button link no-bg no-padding full"
						:href="env.termsLink"
						target="_blank"
					>
						<div class="overlay-menu__strocked-card">
							<p class="account__section__desc">
								{{ $t("overlay-menu.legal-references") }}
								<!-- (T&Cs, Privacy Policy, et al.) -->
							</p>
						</div>
					</a>
				</div>
				<div v-else>
					<div class="overlay-menu__section__header main">
						<h3 class="account__section__title">
							{{ $t("overlay-menu.legal") }}
						</h3>
					</div>
						<div class="overlay-menu__strocked-card">
							<div class="">
								<router-link
									class="account_section button link no-bg no-padding full"
									:to="env.termsLink"
									target="_blank"
								>
									<p
										class="session__form__link button no-bg link"
										style="
											margin: 0;
											padding: 10px 0 0;
											text-align: left;
										"
									>
										{{ $t("overlay-menu.legal-references") }}
									</p>
									<svg
										width="6"
										height="15"
										viewBox="0 0 6 11"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											d="M0.21967 1.28033C-0.0732233 0.987437 -0.0732233 0.512563 0.21967 0.21967C0.512563 -0.0732233 0.987436 -0.0732233 1.28033 0.21967L5.78033 4.71967C6.07322 5.01256 6.07322 5.48744 5.78033 5.78033L1.28033 10.2803C0.987436 10.5732 0.512563 10.5732 0.21967 10.2803C-0.0732233 9.98744 -0.0732233 9.51256 0.21967 9.21967L4.18934 5.25L0.21967 1.28033Z"
										/>
									</svg>
								</router-link>
							</div>
							<div v-if="env.responsibleGaming.link && env.responsibleGaming.section === 'legal'">
								<router-link
									class="account_section button link no-bg no-padding full"
									:to="env.responsibleGaming.link"
								>
									<p
									class="session__form__link button no-bg link"
									style="
										color: var(--green);
										margin: 0;
										padding: 10px 0 0;
										text-align: left;
									"
									>
										{{ $t("legal.responsible-gaming-policy") }}
									</p>
								</router-link>
							</div>
							<div v-if="env.sportBettingRules.link && env.sportBettingRules.section === 'legal'">
								<router-link
									class="account_section button link no-bg no-padding full"
									:to="env.sportBettingRules.link"
								>
									<p
										class="session__form__link button no-bg link"
										style="
											color: var(--green);
											margin: 0;
											padding: 10px 0 0;
											text-align: left;
										"
									>
										{{ $t("legal.sports-betting-rules") }}
									</p>
								</router-link>
							</div>
						</div>
				</div>

				<div class="overlay-menu__section" v-if="env.liteInformation.link">
					<div class="overlay-menu__section__header main">
						<h3>{{ $t("general.lite-version") }}</h3>
					</div>
					<div
						class="overlay-menu__strocked-card button link"
						style="width: 100%"
					>
						<p
							class="account__section__desc"
							style="width: 300px; word-break: break-word; white-space: normal"
						>
						<a :href="env.liteInformation.link" target="_blank"
								class="session__form__link button no-bg link"
								style="
									color: var(--green);
									margin: 0;
									text-align: left;
								">
						{{ $t("general.betika-lite") }}
					</a>

						</p>
					</div>
				</div>

				<div class="overlay-menu__section">
					<div class="overlay-menu__section__header main">
						<h3 class="account__section__title">{{ $t("footer.license") }}</h3>
					</div>
					<div class="overlay-menu__strocked-card">
						<p
							class="account__section__desc"
							style="width: 300px; word-break: break-word; white-space: normal"
						>
							{{ env.licenseDescription }}
						</p>
					</div>
				</div>

				<div class="overlay-menu__section">
					<div class="overlay-menu__section__header main">
						<h3 class="account__section__title">{{env.kyc.legalAgeLimit}}+</h3>
					</div>
					<div class="overlay-menu__strocked-card">
						<p
							class="account__section__desc"
							style="width: 300px; word-break: break-word; white-space: normal"
						>
							{{ $t("footer.age-limit") }}
						</p>
					</div>
				</div>


			<div class="overlay-menu__section" v-if="env.responsibleGaming.link && env.responsibleGaming.section === 'standalone'">
					<div class="overlay-menu__section__header main">
						<h3>{{ $t("legal.responsible-gaming-policy") }}</h3>
					</div>
					<div
						class="overlay-menu__strocked-card button link"
						style="width: 100%"
					>
					<ResponsibleGamingContent />
					</div>
				</div>


				<div class="overlay-menu__section">
					<div class="overlay-menu__section__header main">
						<h3 class="account__section__title">{{ $t("footer.address") }}</h3>
					</div>
					<div class="overlay-menu__strocked-card">
						<p
							class="account__section__desc"
							style="width: 300px; word-break: break-word; white-space: normal"
						>
							{{env.officeAddress}}
						</p>
					</div>
				</div>

				<div class="overlay-menu__country">
					<div class="overlay-menu__country__desc">
						{{ $t("overlay-menu.using-betika") }}
						<button
							class="overlay-menu__country__button"
							@click="canShowBottomSheet = true"
						>
							<img
								:src="selectedCountry.imageSrc"
								:alt="selectedCountry.name"
								width="15px"
							/>
							<span style="margin-left: 8px">{{ selectedCountry.name }}</span>
						</button>
					</div>
				</div>

				<!-- Logout -->
				<div class="spacer"></div>
				<div v-if="isAuthenticated" class="account__section">
					<button @click="logout" class="button full">
						{{ $t("session.logout") }}
					</button>
				</div>

				<div class="overlay-menu__section">
					<div class="desktop-layout__bottom__desc">
						<p class="desktop-layout__bottom__desc__copyright">
							© {{ new Date().getFullYear() }} Betika.com |
							{{ $t("footer.copyright") }}
						</p>
						<div
							class="desktop-layout__bottom__desc__socials"
							v-if="env.socialUrls"
						>
							<a
								v-if="env.socialUrls.facebook"
								:href="env.socialUrls.facebook"
								target="_black"
								class="desktop-layout__bottom__desc__socials__link"
							>
								<svg
									width="16"
									height="17"
									viewBox="0 0 16 17"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
									class="desktop-layout__bottom__desc__socials__icon"
								>
									<path
										d="M15.875 1.25391C15.875 1.00781 15.7695 0.796875 15.5938 0.621094C15.418 0.480469 15.207 0.375 14.9961 0.375H1.00391C0.722656 0.375 0.511719 0.480469 0.371094 0.621094C0.195312 0.796875 0.125 1.00781 0.125 1.25391V15.2461C0.125 15.4922 0.195312 15.7031 0.371094 15.8789C0.511719 16.0547 0.722656 16.125 1.00391 16.125H8.52734V10.0078H6.48828V7.65234H8.52734V5.89453C8.52734 4.91016 8.80859 4.13672 9.37109 3.57422C9.93359 3.04688 10.6719 2.76562 11.5859 2.76562C12.2891 2.76562 12.9219 2.80078 13.4141 2.83594V4.98047H12.1484C11.6914 4.98047 11.375 5.08594 11.1992 5.29688C11.0586 5.47266 10.9883 5.75391 10.9883 6.14062V7.65234H13.3438L13.0273 10.0078H10.9883V16.125H14.9961C15.2422 16.125 15.4531 16.0547 15.6289 15.8789C15.7695 15.7031 15.875 15.4922 15.875 15.2461V1.25391Z"
									/>
								</svg>
							</a>
							<a
								v-if="env.socialUrls.instagram"
								:href="env.socialUrls.instagram"
								target="_black"
								class="desktop-layout__bottom__desc__socials__link"
							>
								<svg
									width="16"
									height="17"
									viewBox="0 0 16 17"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
									class="desktop-layout__bottom__desc__socials__icon"
								>
									<path
										d="M8 4.20703C8.70312 4.20703 9.37109 4.41797 10.0039 4.76953C10.6367 5.12109 11.1289 5.61328 11.4805 6.24609C11.832 6.87891 12.043 7.54688 12.043 8.25C12.043 8.98828 11.832 9.65625 11.4805 10.2891C11.1289 10.9219 10.6367 11.4141 10.0039 11.7656C9.37109 12.1172 8.70312 12.293 8 12.293C7.26172 12.293 6.59375 12.1172 5.96094 11.7656C5.32812 11.4141 4.83594 10.9219 4.48438 10.2891C4.13281 9.65625 3.95703 8.98828 3.95703 8.25C3.95703 7.54688 4.13281 6.87891 4.48438 6.24609C4.83594 5.61328 5.32812 5.12109 5.96094 4.76953C6.59375 4.41797 7.26172 4.20703 8 4.20703ZM8 10.8867C8.70312 10.8867 9.33594 10.6406 9.86328 10.1133C10.3555 9.62109 10.6367 8.98828 10.6367 8.25C10.6367 7.54688 10.3555 6.91406 9.86328 6.38672C9.33594 5.89453 8.70312 5.61328 8 5.61328C7.26172 5.61328 6.62891 5.89453 6.13672 6.38672C5.60938 6.91406 5.36328 7.54688 5.36328 8.25C5.36328 8.98828 5.60938 9.62109 6.13672 10.1133C6.62891 10.6406 7.26172 10.8867 8 10.8867ZM13.168 4.03125C13.168 3.78516 13.0625 3.57422 12.8867 3.36328C12.6758 3.1875 12.4648 3.08203 12.2188 3.08203C11.9375 3.08203 11.7266 3.1875 11.5508 3.36328C11.3398 3.57422 11.2695 3.78516 11.2695 4.03125C11.2695 4.3125 11.3398 4.52344 11.5508 4.69922C11.7266 4.91016 11.9375 4.98047 12.2188 4.98047C12.4648 4.98047 12.6758 4.91016 12.8516 4.69922C13.0273 4.52344 13.1328 4.3125 13.168 4.03125ZM15.8398 4.98047C15.8398 5.64844 15.875 6.73828 15.875 8.25C15.875 9.79688 15.8398 10.8867 15.8047 11.5547C15.7695 12.2227 15.6641 12.7852 15.5234 13.2773C15.3125 13.875 14.9609 14.4023 14.5391 14.8242C14.1172 15.2461 13.5898 15.5625 13.0273 15.7734C12.5352 15.9492 11.9375 16.0547 11.2695 16.0898C10.6016 16.125 9.51172 16.125 8 16.125C6.45312 16.125 5.36328 16.125 4.69531 16.0898C4.02734 16.0547 3.46484 15.9492 2.97266 15.7383C2.375 15.5625 1.84766 15.2461 1.42578 14.8242C1.00391 14.4023 0.6875 13.875 0.476562 13.2773C0.300781 12.7852 0.195312 12.2227 0.160156 11.5547C0.125 10.8867 0.125 9.79688 0.125 8.25C0.125 6.73828 0.125 5.64844 0.160156 4.98047C0.195312 4.3125 0.300781 3.71484 0.476562 3.22266C0.6875 2.66016 1.00391 2.13281 1.42578 1.71094C1.84766 1.28906 2.375 0.9375 2.97266 0.726562C3.46484 0.585938 4.02734 0.480469 4.69531 0.445312C5.36328 0.410156 6.45312 0.375 8 0.375C9.51172 0.375 10.6016 0.410156 11.2695 0.445312C11.9375 0.480469 12.5352 0.585938 13.0273 0.726562C13.5898 0.9375 14.1172 1.28906 14.5391 1.71094C14.9609 2.13281 15.3125 2.66016 15.5234 3.22266C15.6641 3.71484 15.7695 4.3125 15.8398 4.98047ZM14.1523 12.8906C14.293 12.5039 14.3633 11.8711 14.4336 10.9922C14.4336 10.5 14.4688 9.76172 14.4688 8.8125V7.6875C14.4688 6.73828 14.4336 6 14.4336 5.50781C14.3633 4.62891 14.293 3.99609 14.1523 3.60938C13.8711 2.90625 13.3438 2.37891 12.6406 2.09766C12.2539 1.95703 11.6211 1.88672 10.7422 1.81641C10.2148 1.81641 9.47656 1.78125 8.5625 1.78125H7.4375C6.48828 1.78125 5.75 1.81641 5.25781 1.81641C4.37891 1.88672 3.74609 1.95703 3.35938 2.09766C2.62109 2.37891 2.12891 2.90625 1.84766 3.60938C1.70703 3.99609 1.60156 4.62891 1.56641 5.50781C1.53125 6.03516 1.53125 6.77344 1.53125 7.6875V8.8125C1.53125 9.76172 1.53125 10.5 1.56641 10.9922C1.60156 11.8711 1.70703 12.5039 1.84766 12.8906C2.12891 13.6289 2.65625 14.1211 3.35938 14.4023C3.74609 14.543 4.37891 14.6484 5.25781 14.6836C5.75 14.7188 6.48828 14.7188 7.4375 14.7188H8.5625C9.51172 14.7188 10.25 14.7188 10.7422 14.6836C11.6211 14.6484 12.2539 14.543 12.6406 14.4023C13.3438 14.1211 13.8711 13.5938 14.1523 12.8906Z"
									/>
								</svg>
							</a>
							<a
								v-if="env.socialUrls.twitter"
								:href="env.socialUrls.twitter"
								target="_black"
								class="desktop-layout__bottom__desc__socials__link"
								><svg
									width="18"
									height="16"
									viewBox="0 0 20 20"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
									class="desktop-layout__bottom__desc__socials__icon"
								>
									<path
										d="M15.2716 1.58655H18.0828L11.9411 8.60612L19.1663 18.1582H13.509L9.07804 12.3649L4.00796 18.1582H1.19503L7.7642 10.65L0.833008 1.58655H6.63393L10.6392 6.88182L15.2716 1.58655ZM14.2849 16.4755H15.8427L5.7875 3.18082H4.11589L14.2849 16.4755Z"
									/>
								</svg>
							</a>
							<a
								v-if="env.socialUrls.youtube"
								:href="env.socialUrls.youtube"
								target="_black"
								class="desktop-layout__bottom__desc__socials__link"
							>
								<svg
									width="21"
									height="14"
									viewBox="0 0 21 14"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
									class="desktop-layout__bottom__desc__socials__icon"
								>
									<path
										d="M19.7109 2.60938C19.8516 3.24219 19.9922 4.22656 20.0625 5.49219L20.0977 7.25L20.0625 9.00781C19.9922 10.3438 19.8516 11.293 19.7109 11.9258C19.5703 12.3477 19.3594 12.6992 19.0781 12.9805C18.7617 13.2969 18.4102 13.5078 17.9883 13.6133C17.3555 13.7891 15.9492 13.8945 13.6992 13.9648L10.5 14L7.30078 13.9648C5.05078 13.8945 3.60938 13.7891 3.01172 13.6133C2.58984 13.5078 2.20312 13.2969 1.92188 12.9805C1.60547 12.6992 1.39453 12.3477 1.28906 11.9258C1.11328 11.293 1.00781 10.3438 0.9375 9.00781L0.902344 7.25C0.902344 6.75781 0.902344 6.16016 0.9375 5.49219C1.00781 4.22656 1.11328 3.24219 1.28906 2.60938C1.39453 2.1875 1.60547 1.83594 1.92188 1.51953C2.20312 1.23828 2.58984 1.02734 3.01172 0.886719C3.60938 0.746094 5.05078 0.605469 7.30078 0.535156L10.5 0.5L13.6992 0.535156C15.9492 0.605469 17.3555 0.746094 17.9883 0.886719C18.4102 1.02734 18.7617 1.23828 19.0781 1.51953C19.3594 1.83594 19.5703 2.1875 19.7109 2.60938ZM8.53125 10.1328L13.5586 7.25L8.53125 4.40234V10.1328Z"
									/>
								</svg>
							</a>
							<a
								v-if="env.socialUrls.linkedin"
								:href="env.socialUrls.linkedin"
								target="_black"
								class="desktop-layout__bottom__desc__socials__link"
							>
								<svg
									width="16"
									height="17"
									viewBox="0 0 16 17"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
									class="desktop-layout__bottom__desc__socials__icon"
								>
									<path
										d="M14.75 0.375C15.0312 0.375 15.3125 0.515625 15.5234 0.726562C15.7344 0.9375 15.875 1.21875 15.875 1.5V15C15.875 15.3164 15.7344 15.5977 15.5234 15.8086C15.3125 16.0195 15.0312 16.125 14.75 16.125H1.25C0.933594 16.125 0.652344 16.0195 0.441406 15.8086C0.230469 15.5977 0.125 15.3164 0.125 15V1.5C0.125 1.21875 0.230469 0.9375 0.441406 0.726562C0.652344 0.515625 0.933594 0.375 1.25 0.375H14.75ZM4.87109 13.875H4.90625V6.35156H2.55078V13.875H4.87109ZM3.71094 5.33203C4.0625 5.33203 4.37891 5.22656 4.66016 4.94531C4.94141 4.66406 5.08203 4.34766 5.08203 3.99609C5.08203 3.64453 4.94141 3.32812 4.66016 3.04688C4.37891 2.76562 4.0625 2.625 3.71094 2.625C3.32422 2.625 3.00781 2.76562 2.76172 3.04688C2.48047 3.32812 2.375 3.64453 2.375 3.99609C2.375 4.34766 2.48047 4.66406 2.76172 4.94531C3.00781 5.22656 3.32422 5.33203 3.71094 5.33203ZM13.625 13.875V9.76172C13.625 8.60156 13.4492 7.75781 13.1328 7.19531C12.6758 6.52734 11.9023 6.17578 10.8477 6.17578C10.2852 6.17578 9.82812 6.31641 9.40625 6.5625C9.05469 6.77344 8.77344 7.05469 8.63281 7.37109H8.59766V6.35156H6.34766V13.875H8.66797V10.1484C8.66797 9.58594 8.73828 9.12891 8.91406 8.8125C9.125 8.42578 9.51172 8.21484 10.0742 8.21484C10.6016 8.21484 10.9531 8.46094 11.1289 8.88281C11.2344 9.16406 11.3047 9.62109 11.3047 10.2188V13.875H13.625Z"
									/>
								</svg>
							</a>
							<a
								v-if="env.socialUrls.tiktok"
								:href="env.socialUrls.tiktok"
								target="_black"
								class="desktop-layout__bottom__desc__socials__link">
								<svg width="16"
									height="15"
									viewBox="0 0 16 20"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
									class="desktop-layout__bottom__desc__socials__icon">
									<path d="M10 0C11.1046 0 12 0.89543 12 2C12 3.44733 13.03 4.6618 14.3984 4.93991C15.4808 5.15992 16.1799 6.21575 15.9599 7.29819C15.7399 8.3806 14.6841 9.0798 13.6016 8.8598C13.0406 8.7457 12.5037 8.5646 12 8.3252V14C12 17.3137 9.3137 20 6 20C2.68629 20 0 17.3137 0 14C0 11.2015 1.91407 8.8551 4.50148 8.1891C5.57119 7.91382 6.6616 8.5578 6.9369 9.6275C7.2122 10.6972 6.5682 11.7876 5.49852 12.0629C4.63547 12.285 4 13.0708 4 14C4 15.1046 4.89543 16 6 16C7.1046 16 8 15.1046 8 14V2C8 0.89543 8.8954 0 10 0Z" />
								</svg>
							</a>

						</div>
					</div>
				</div>

				<div class="overlay-menu__section" v-if="env.regulatorLogo !== ''">
					<div class="desktop-layout__bottom__desc">
						<p class="desktop-layout__bottom__desc__regulator">
							{{ $t("overlay-menu.regulated-by") }}
						</p>
						<div class="desktop-layout__bottom__desc__socials">
							<img
								class="desktop-layout__bottom__desc__socials__logo"
								:src="env.regulatorLogo"
							/>
						</div>
					</div>
				</div>
			</div>
		</div>
		<bottom-sheet
			:ref="'bottomSheet'"
			v-if="canShowBottomSheet"
			@close="closeBottomSheet"
			@has-mounted="showBottomSheet"
		>
			<div class="country-choice__container">
				<h2>{{ $t("general.switch-country") }}</h2>
				<div
					:class="[selectedCountryCode == country.code ? 'selected' : '']"
					class="country-choice__list"
					v-for="country in env.availableCountries"
					:key="country.code"
					@click="updateSelectedCountry(country)"
				>
					<div class="country-choice__left">
						<img :src="country.imageSrc" :alt="country.name" width="25px" />
						<span class="country-choice__name">{{ country.name }}</span>
					</div>
					<div class="country-choice__right">
						<input
							class="country-choice__checkbox"
							type="checkbox"
							:checked="selectedCountryCode == country.code ? true : false"
						/>
						<span class="country-choice__checkmark"></span>
					</div>
				</div>
				<button @click="confirmCountry" class="country-choice__button">
					{{ $t("general.proceed") }}
				</button>
			</div>
		</bottom-sheet>
	</div>
</template>

<script>
import Recommendation from "../Session/Account/Recommendation.vue";
import AutoRefreshSwitcher from "./../Session/Account/AutoRefreshSwitcher.vue";
import Help from "./../Session/Account/Help.vue";
import ThemeSwitcher from "./../Session/Account/ThemeSwitcher.vue";
import Button from "./Button.vue";
import ResponsibleGamingContent from "./ResponsibleGamingContent.vue";
import HelpAction from "../Session/Account/HelpActions.vue";
export default {
	name: "OverlayMenu",
	props: ["showOverlayMenu"],
	components: {
		HelpAction,
		ThemeSwitcher,
		AutoRefreshSwitcher,
		Help,
		Button,
		Recommendation,
		ResponsibleGamingContent,
	},
	data() {
		return {
			canShowBottomSheet: false,
			selectedCountryCode: null,
		};
	},
	mounted() {
		let vm = this;
		vm.selectedCountryCode =
			process.env.DEPLOY_ENV == "web" || process.env.DEPLOY_ENV == "mobile_app"
				? process.env.COUNTRY_CODE
				: JSON.parse(localStorage.getItem("countryCode"));
	},
	methods: {
		liveChat() {
			this.waitForZendesk(() => {
				zE('messenger', 'show')
				zE('messenger', 'open')

				zE("messenger:on", "close", function () {
					zE('messenger', 'hide')
				})
			})
		},
		openRoute(path) {
			let vm = this;
			vm.$router.push(path);
			vm.$emit("close");
			return;
		},
		confirmCountry() {
			let vm = this;
			let chosenCountry = vm.env.availableCountries.find((country) => {
				return country.code == vm.selectedCountryCode;
			});
			localStorage.clear();
			localStorage.countryCode = JSON.stringify(vm.selectedCountryCode);
			vm.$cookie.set("btk-browse-country", vm.selectedCountryCode, 365);
			let localeToSave = chosenCountry.defaultPath.split("/")[1];
			vm.$cookie.set("btk-lang-cn", localeToSave, 10 * 365);
			window.location.href = `${vm.env.desktopUrl}${chosenCountry.defaultPath}`;
		},
		updateSelectedCountry(country) {
			let vm = this;
			vm.selectedCountryCode = country.code;
		},
		showBottomSheet() {
			let vm = this;
			// this.canShowBottomSheet = true;
			this.$nextTick(() => {
				this.$refs.bottomSheet.setState("open");
			});
		},
		closeBottomSheet() {
			this.$refs.bottomSheet.setState("close");
			this.$nextTick(() => {
				this.canShowBottomSheet = false;
			});
		},
		logout() {
			let vm = this;

			this.$auth.logout();

			localStorage.removeItem("notification-banner-message");
			// Reset to default order
			if (this.$store.getters.layout == "Mobile") {
				this.$root.$emit("reset-sports-list");
				this.$store.commit("settings/updateToastDropMenu", false);
			}
			vm.$notifications.add({
				message: this.$t("session.you-have-been-logged-out-successfully"),
				type: "success",
				title: this.$t("session.logged-out"),
				duration: 5000,
			});
			this.$forceUpdate();
			this.$emit("close");
			this.$router.replace("/");
		},
		goToApp() {
			this.$refs.appLink.click();
		},
	},
	computed: {
		selectedCountry() {
			let vm = this;
			let filteredCountry = vm.env.availableCountries.filter(
				(country) => country.code == vm.selectedCountryCode
			);
			return filteredCountry.length > 0 ? filteredCountry[0] : {};
		},
		isAuthenticated() {
			return this.$store.getters.authenticated;
		},
		jackpot() {
			let vm = this;
			return vm.env.jackpots.length !== 0
				? vm.env.jackpots.find(
						(jackpot) =>
							jackpot.id === vm.env.defaultJackpotId && jackpot.isEnabled
					)
				: [];
		},
		jackpotSababisha() {
			let vm = this;
			return vm.env.jackpots.length !== 0
				? vm.env.jackpots.find(
						(jackpot) => jackpot.id === null && jackpot.isEnabled
					)
				: "";
		},
	},
};
</script>

<style lang="scss">
.spacer {
	width: 100%;
	margin: 25px;
}
.super:last-child {
	margin-bottom: -10px;
}
.overlay-menu {
	position: fixed;
	top: 0;
	left: -500px;
	bottom: 0;
	right: initial;
	height: 100%;
	margin: 0 auto;
	overflow-x: hidden;
	max-width: calc(100% + 10px);
	transition: all 0.2s;
	background: rgba(0, 0, 0, 0.75);
	z-index: 999999999;

	// Setting for disabling scrollbars on Chrome, Firefox, Internet Explorer, Safari, etc.
	scrollbar-width: none; /* Firefox */
	-ms-overflow-style: none; /* Internet Explorer 10+ */
	&::-webkit-scrollbar {
		/* Safari and Chrome */
		width: 0px !important;
		height: 0px;
	}

	&.sidenavopen {
		left: 0;
		right: 0;

		.hambager {
			&__bar {
				transition-delay: 0.2s;

				&.short {
					transition-delay: 0.3s;
				}
			}
		}
	}
	&__close {
		font-size: var(--font-largest);
		@media not all and (min-resolution: 0.001dpcm) {
			font-size: 200%;
		}
		cursor: pointer;
	}
	&__container {
		height: 100%;
		max-height: 100vh;
		overflow-y: scroll;
		background: var(--black-dark-10);
		padding: 15px 10px;
		@media (min-width: 1023px) {
			width: max-content;
		}
		// Setting for disabling scrollbars on Chrome, Firefox, Internet Explorer, Safari, etc.
		scrollbar-width: none; /* Firefox */
		-ms-overflow-style: none; /* Internet Explorer 10+ */
		&::-webkit-scrollbar {
			/* Safari and Chrome */
			width: 0px !important;
			height: 0px !important;
		}
	}
	&__country {
		display: flex;
		justify-content: center;
		margin-top: 25px;
		&__button {
			font-size: var(--font-small);
			border: none;
			background: var(--light-gray);
			color: var(--black);
			border-radius: 25px;
			padding: 5px 10px;
			white-space: nowrap;
			display: flex;
			flex-direction: row;
			align-items: center;
			margin-left: 5px;
		}
		&__desc {
			display: flex;
			align-items: center;
		}
	}
	&__header {
		display: flex;
		align-items: center;
		margin-bottom: 15px;
	}
	&__logo {
		display: flex;
		justify-content: flex-end;
		width: 100%;
	}
	&__nav {
		margin-top: 10px;
		a,
		&__button {
			display: flex !important;
			background: none !important;
			border: none;
			padding: 0;
			font-size: var(--font-large);
			font-weight: var(--font-weight-lighter);
		}
		&__icon {
			width: 20px;
			height: 20px;
			fill: var(--black);
			margin-right: 15px;
		}
		&__item {
			padding: 10px 0;
		}
		&__link {
			text-decoration: none;
			font-weight: var(--font-weight-normal);
			color: var(--light-black);
			display: flex;
			align-items: center;
		}
	}
	&__section {
		&__header {
			&.main {
				margin-left: 20px;
				margin-bottom: 20px;
				margin-top: 20px;
			}
		}
		h3 {
			margin-bottom: 5px;
			font-weight: var(--font-weight-medium);
		}
		p {
			margin: 0px;
			color: var(--light-dark-blue);
			font-weight: var(--font-weight-lighter);
		}
		.desktop-layout__bottom__desc {
			display: block;
			text-align: center;
			margin-top: 30px;
		}
		.desktop-layout__bottom__desc__socials {
			display: block;
			margin-top: 10px;
		}
	}
	&__strocked-card {
		border: 1px solid var(--light-gray-border);
		background-color: var(--black-dark-20);
		border-radius: 8px;
		padding: 20px;
	}
	&__line {
		border-bottom: 1px solid var(--line-11);
		margin: 10px 0;
	}

	&__legal {
		display: flex;
		justify-content: space-between;
		vertical-align: revert;
	}
}
.account {
	&__section {
		&.display {
			h3 {
				margin-top: 0;
			}
		}
	}
}
</style>
